/**
 * A function to create a log object for the 'groupSettingsSave' event (evid: 10)
 *
 * Event description: saves new settings
 *
 * @param {groupSettingsSaveParams} params - The parameters for this event
 * @property {GUID} group_id - group ID
 * @property {boolean} show_media - bool
 * @property {boolean} display_cover - t/f
 * @property {string} tabName - 'details'/'tabs'/'permissions'
 * @property {string} edit_tab - 'discussions'/'media'/'members'/'about'
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - bizmgr/site/members_area/oneapp
 * @property {string} origin - save_button
 * @property {boolean} member_toggle - bool
 * @property {string} type - 'private'/'public'/'secret'
 * @property {boolean} show_members - bool
 * @property {boolean} withPhoto - t/f
 * @property {boolean} tabToggle - t/f
 * @property {boolean} edited_description - if description was edited
 * @property {boolean} edited_photo - if photo was edited
 * @property {boolean} edited_name - if name was edited
 * @property {boolean} edited_type - if type was edited
 * @return {LogObject<groupSettingsSaveParams>} LogObject<groupSettingsSaveParams>
 */
export function groupSettingsSave(params) {
    return { evid: 10, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'joinRequestSent' event (evid: 1002)
 *
 * Event description: When member clicks Join Private group
 *
 * @param {joinRequestSentParams} params - The parameters for this event
 * @property {GUID} groupId - group ID
 * @property {string} origin - private / secret
 * @property {GUID} inviteId - invite ID
 * @property {GUID} msid - msid
 * @return {LogObject<joinRequestSentParams>} LogObject<joinRequestSentParams>
 */
export function joinRequestSent(params) {
    return { evid: 1002, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverGroupCreated' event (evid: 1006)
 *
 * Event description: When user creates a club successfully and it registered on the server successfully
 *
 * @param {serverGroupCreatedParams} params - The parameters for this event
 * @property {boolean} isFromEditorTemplate - is automatic group created from Editor Templates
 * @property {string} creatorType - member or owner/admin
 * @property {GUID} installationId - installation_id
 * @property {string} category - group_creation_requested
 * @property {string} type - private/secret/public
 * @property {boolean} isAutomatic - is automatic group
 * @property {GUID} clubId - club_id
 * @property {string} appVersion - app version
 * @property {string} created_from - where group was created
 * @property {boolean} isFromAiAssistant - if the group was created by AI
 * @return {LogObject<serverGroupCreatedParams>} LogObject<serverGroupCreatedParams>
 */
export function serverGroupCreated(params) {
    return { evid: 1006, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsInstallSrc111Evid1010' event (evid: 1010)
 *
 * Event description: Server group installation event
 *
 * @param {groupsInstallSrc111Evid1010Params} params - The parameters for this event
 * @property {GUID} appInstanceId - unique identifier of the app
 * @property {string} wixClientArtifactId - wix client artifact id
 * @property {Url} referer - Referer URL
 * @property {Url} wixForwardedUrl - Referer forwarded URL
 * @return {LogObject<groupsInstallSrc111Evid1010Params>} LogObject<groupsInstallSrc111Evid1010Params>
 */
export function groupsInstallSrc111Evid1010(params) {
    return { evid: 1010, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverGroupDeleted' event (evid: 1022)
 *
 * Event description: When user deletes a community successfully and it registered on the server successfully
 *
 * @param {serverGroupDeletedParams} params - The parameters for this event
 * @property {GUID} installationId - installation_id
 * @property {string} category - category
 * @property {GUID} msid - msid
 * @property {GUID} clubId - club_id
 * @return {LogObject<serverGroupDeletedParams>} LogObject<serverGroupDeletedParams>
 */
export function serverGroupDeleted(params) {
    return { evid: 1022, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverMemberJoined' event (evid: 1025)
 *
 * Event description: When member successfully joined a club and this was registered on the server.
 *
 * @param {serverMemberJoinedParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} installationId - installation_id
 * @property {GUID} groupId - group_id
 * @property {string} origin - origin
 * @property {GUID} inviteId - auto invite id
 * @property {string} type - type
 * @property {GUID} msid - msid
 * @property {boolean} is_manual - is_manual
 * @property {GUID} siteMemberId - site_member_id
 * @property {string} appVersion - app version
 * @property {string} created_from - where do we have events
 * @return {LogObject<serverMemberJoinedParams>} LogObject<serverMemberJoinedParams>
 */
export function serverMemberJoined(params) {
    return { evid: 1025, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'followMember' event (evid: 12)
 *
 * Event description: follow group member
 *
 * @param {followMemberParams} params - The parameters for this event
 * @property {GUID} group_id - group
 * @property {string} userEntry - site
 * @property {string} origin - discussion_tab
 * @property {GUID} site_member_id - site member
 * @property {string} action - follow/unfollow
 * @return {LogObject<followMemberParams>} LogObject<followMemberParams>
 */
export function followMember(params) {
    return { evid: 12, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'memberTabAdminActionClick' event (evid: 14)
 *
 * Event description: admin actions in member tab (3 dots)
 *
 * @param {memberTabAdminActionClickParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} userEntry - site / bizmngr
 * @property {string} origin - member_tab_member_option_clk
 * @property {GUID} site_member_id - member
 * @property {string} action - remove_admin/remove_member/set_admin
 * @return {LogObject<memberTabAdminActionClickParams>} LogObject<memberTabAdminActionClickParams>
 */
export function memberTabAdminActionClick(params) {
    return { evid: 14, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clubPostOptionsEditEditSaved' event (evid: 146)
 *
 * Event description: Club post -> options --> edit -> edit saved.
 *
 * @param {clubPostOptionsEditEditSavedParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {GUID} club_id - club_id
 * @property {string} container - container
 * @property {string} userClass - user_class
 * @property {string} postId - post_id
 * @property {GUID} clubId - club_id
 * @property {GUID} postItemId - post_item_id
 * @return {LogObject<clubPostOptionsEditEditSavedParams>} LogObject<clubPostOptionsEditEditSavedParams>
 */
export function clubPostOptionsEditEditSaved(params) {
    return { evid: 146, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'memberTabAdminActionDone' event (evid: 15)
 *
 * Event description: completed admin action
 *
 * @param {memberTabAdminActionDoneParams} params - The parameters for this event
 * @property {GUID} group_id - group
 * @property {string} userEntry - site / bizmngr
 * @property {string} origin - origin: dialog_screen_btn_clk
 * @property {GUID} site_member_id - member id
 * @property {string} action - remove_admin/remove_member/set_admin
 * @return {LogObject<memberTabAdminActionDoneParams>} LogObject<memberTabAdminActionDoneParams>
 */
export function memberTabAdminActionDone(params) {
    return { evid: 15, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchServerOutputSrc111Evid1520' event (evid: 1520)
 *
 * Event description: Output results on user's search request
 *
 * @param {groupsSearchServerOutputSrc111Evid1520Params} params - The parameters for this event
 * @property {string} inputText - user's request
 * @property {string} outputJson - json with results
 * @property {string} contentType - search content type: posts, comments, groups
 * @return {LogObject<groupsSearchServerOutputSrc111Evid1520Params>} LogObject<groupsSearchServerOutputSrc111Evid1520Params>
 */
export function groupsSearchServerOutputSrc111Evid1520(params) {
    return { evid: 1520, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupListSettingsOpen' event (evid: 16)
 *
 * Event description: user opened group list settings
 *
 * @param {groupListSettingsOpenParams} params - The parameters for this event
 * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
 * @property {string} origin - origin
 * @return {LogObject<groupListSettingsOpenParams>} LogObject<groupListSettingsOpenParams>
 */
export function groupListSettingsOpen(params) {
    return { evid: 16, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsBoLoaded' event (evid: 17)
 *
 * Event description: backoffice loaded
 *
 * @param {groupsBoLoadedParams} params - The parameters for this event
 * @property {string} origin - pnl_manage_groups_btn / settings_pnl_manage_groups_btn / on_group_manage_groups_btn / bo_groups_btn
 * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
 * @property {string} pageName - page name
 * @property {string} page_name - page name
 * @property {string} group_id - Unique identifier of the group
 * @return {LogObject<groupsBoLoadedParams>} LogObject<groupsBoLoadedParams>
 */
export function groupsBoLoaded(params) {
    return { evid: 17, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsOpenGroupSettingsBm' event (evid: 2)
 *
 * Event description: Groups -> Open Group Settings from Group List in BM
 *
 * @param {groupsOpenGroupSettingsBmParams} params - The parameters for this event
 * @property {GUID} groupId - group iD
 * @property {string} userEntry - bizmngr
 * @property {string} origin - group_area, three_dots
 * @return {LogObject<groupsOpenGroupSettingsBmParams>} LogObject<groupsOpenGroupSettingsBmParams>
 */
export function groupsOpenGroupSettingsBm(params) {
    return { evid: 2, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupSettingsOpen' event (evid: 21)
 *
 * Event description: Group settings clicked
 *
 * @param {groupSettingsOpenParams} params - The parameters for this event
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
 * @property {boolean} withPimple - true/false
 * @property {string} origin - on_group_settings_btn
 * @return {LogObject<groupSettingsOpenParams>} LogObject<groupSettingsOpenParams>
 */
export function groupSettingsOpen(params) {
    return { evid: 21, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pcrClickSrc111Evid220' event (evid: 220)
 *
 * Event description: Click on post/reaction/comment/reply button
 *
 * @param {pcrClickSrc111Evid220Params} params - The parameters for this event
 * @property {GUID} msid - unique identifier of site
 * @property {string} member_id - unique identifier of member
 * @property {string} created_from - livesite, owner, spaces
 * @property {string} detailed_location - central_feed, groups_feed, members_area, onboarding
 * @property {string} type - post, comment, reply
 * @property {string} react_to - post/comment
 * @property {string} reaction_type - heart, like
 * @property {string} created_by - owner, member
 * @property {boolean} permission - if user can post/comment/react
 * @return {LogObject<pcrClickSrc111Evid220Params>} LogObject<pcrClickSrc111Evid220Params>
 */
export function pcrClickSrc111Evid220(params) {
    return { evid: 220, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsFeedNewItemPostedSuccessfully' event (evid: 2201)
 *
 * Event description: when a feed item is successfully written to the server --not success post (event 82)
 *
 * @param {groupsFeedNewItemPostedSuccessfullyParams} params - The parameters for this event
 * @property {string} reactionType - reaction type
 * @property {GUID} uuid - User UID
 * @property {number} price - price
 * @property {GUID} saleItemId - sale_item_id
 * @property {string} reaction_type - reaction type
 * @property {string} container - container
 * @property {number} count_files - count_files
 * @property {string} userEntry - user_entry
 * @property {string} activityType - type of Activity post / null for regular posts
 * @property {string} id - id
 * @property {string} userClass - user_class
 * @property {GUID} postId - post_id
 * @property {string} content2 - if content field full, data saved here
 * @property {boolean} withMention - with_mention
 * @property {string} content - post / comment text
 * @property {string} postType - to filter Activity posts / null if regular post
 * @property {number} count_mentions - count_mentions
 * @property {number} length - length
 * @property {string} type - type
 * @property {string} subType - sub_type
 * @property {GUID} commentId - comment_id
 * @property {boolean} isAutomatic - is_automatic
 * @property {boolean} withPhoto - with_photo
 * @property {GUID} clubId - club_id
 * @property {string} createdFrom - where post was created
 * @property {string} appVersion - app version
 * @return {LogObject<groupsFeedNewItemPostedSuccessfullyParams>} LogObject<groupsFeedNewItemPostedSuccessfullyParams>
 */
export function groupsFeedNewItemPostedSuccessfully(params) {
    return { evid: 2201, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverGroupConnectedToEvent' event (evid: 2202)
 *
 * Event description: Group Connected to Event
 *
 * @param {serverGroupConnectedToEventParams} params - The parameters for this event
 * @property {GUID} group_id - id
 * @property {GUID} groupId - id
 * @property {GUID} groupid - id
 * @property {GUID} club_id - id
 * @property {GUID} event_id - id
 * @return {LogObject<serverGroupConnectedToEventParams>} LogObject<serverGroupConnectedToEventParams>
 */
export function serverGroupConnectedToEvent(params) {
    return { evid: 2202, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverGroupDisconnectedFromEvent' event (evid: 2203)
 *
 * Event description: Group Disconnected from Event
 *
 * @param {serverGroupDisconnectedFromEventParams} params - The parameters for this event
 * @property {GUID} group_id - id
 * @property {GUID} club_id - id
 * @property {GUID} event_id - id
 * @return {LogObject<serverGroupDisconnectedFromEventParams>} LogObject<serverGroupDisconnectedFromEventParams>
 */
export function serverGroupDisconnectedFromEvent(params) {
    return { evid: 2203, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverGroupConnectedToPaidPlan' event (evid: 2204)
 *
 * Event description: Group Connected to Paid Plan
 *
 * @param {serverGroupConnectedToPaidPlanParams} params - The parameters for this event
 * @property {GUID} paid_plan_id - id
 * @property {GUID} pp_id - paid plan id
 * @return {LogObject<serverGroupConnectedToPaidPlanParams>} LogObject<serverGroupConnectedToPaidPlanParams>
 */
export function serverGroupConnectedToPaidPlan(params) {
    return { evid: 2204, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverGroupDisconnectedFromPaidPlan' event (evid: 2205)
 *
 * Event description: Group Disconnected from Paid Plan
 *
 * @param {serverGroupDisconnectedFromPaidPlanParams} params - The parameters for this event
 * @property {GUID} group_id - id
 * @property {GUID} groupId - id
 * @property {GUID} groupid - id
 * @property {GUID} pp_id - id
 * @property {GUID} paid_plan_id - id
 * @return {LogObject<serverGroupDisconnectedFromPaidPlanParams>} LogObject<serverGroupDisconnectedFromPaidPlanParams>
 */
export function serverGroupDisconnectedFromPaidPlan(params) {
    return { evid: 2205, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'serverNotificationSent' event (evid: 2206)
 *
 * Event description: Notification Sent
 *
 * @param {serverNotificationSentParams} params - The parameters for this event
 * @property {GUID} group_id - groupid
 * @property {string} template_id - templateid
 * @property {GUID} autoinviteid - autoinviteid
 * @property {string} email - email
 * @property {GUID} correlation_id - id
 * @property {GUID} auto_invite_id - id
 * @property {string} templateid - templateid
 * @property {GUID} correlationid - correlationid
 * @property {GUID} groupid - groupid
 * @return {LogObject<serverNotificationSentParams>} LogObject<serverNotificationSentParams>
 */
export function serverNotificationSent(params) {
    return { evid: 2206, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsCaptchaRequired' event (evid: 2208)
 *
 * Event description: Trigger - Captcha Required Popup
 *
 * @param {groupsCaptchaRequiredParams} params - The parameters for this event
 * @property {GUID} group_id - group id
 * @property {GUID} uuid - guid
 * @property {GUID} msid - guid
 * @return {LogObject<groupsCaptchaRequiredParams>} LogObject<groupsCaptchaRequiredParams>
 */
export function groupsCaptchaRequired(params) {
    return { evid: 2208, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsCaptchaResult' event (evid: 2209)
 *
 * Event description: Result of Captcha
 * Result:
 * OK - user passed test
 * Fail - user failed captcha
 * None - user closed captcha
 *
 * @param {groupsCaptchaResultParams} params - The parameters for this event
 * @property {GUID} group_id - group id
 * @property {GUID} uuid - guid
 * @property {string} result - OK / Fail / None
 * @property {GUID} msid - guid
 * @return {LogObject<groupsCaptchaResultParams>} LogObject<groupsCaptchaResultParams>
 */
export function groupsCaptchaResult(params) {
    return { evid: 2209, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clubPostOptionsFollowPost' event (evid: 223)
 *
 * Event description: Club post -> options -> Follow Post.
 *
 * @param {clubPostOptionsFollowPostParams} params - The parameters for this event
 * @property {string} container - container
 * @property {string} userClass - user_class
 * @property {GUID} postId - post_id
 * @property {string} value - value
 * @property {GUID} clubId - club_id
 * @return {LogObject<clubPostOptionsFollowPostParams>} LogObject<clubPostOptionsFollowPostParams>
 */
export function clubPostOptionsFollowPost(params) {
    return { evid: 223, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inviteMembersClick' event (evid: 25)
 *
 * Event description: clicked invite members
 *
 * @param {inviteMembersClickParams} params - The parameters for this event
 * @property {GUID} group_id - group
 * @property {string} userEntry - bizmngr / site / etc...
 * @property {string} origin - top_pnl_invite_btn / invite_modal_scrn_invite_btn
 * @return {LogObject<inviteMembersClickParams>} LogObject<inviteMembersClickParams>
 */
export function inviteMembersClick(params) {
    return { evid: 25, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsMemberRequestToCreateAGroupApproveDecline' event (evid: 26)
 *
 * Event description: Groups -> member request to create a group -> approve / decline
 *
 * @param {groupsMemberRequestToCreateAGroupApproveDeclineParams} params - The parameters for this event
 * @property {GUID} groupId - value
 * @property {string} userEntry - bizmgr/site/ null if oneapp
 * @property {string} actionType - approve / decline
 * @property {string} origin - user_lvl_btn
 * @property {string} memberUuid - member ID
 * @property {GUID} memberId - value
 * @property {boolean} isAll - Decline or approve all true / false
 * @return {LogObject<groupsMemberRequestToCreateAGroupApproveDeclineParams>} LogObject<groupsMemberRequestToCreateAGroupApproveDeclineParams>
 */
export function groupsMemberRequestToCreateAGroupApproveDecline(params) {
    return { evid: 26, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addMemberSkipClicked' event (evid: 27)
 *
 * Event description: Add Member Skip Clicked
 *
 * @param {addMemberSkipClickedParams} params - The parameters for this event
 * @property {GUID} group_id - group ID
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - oneapp
 * @property {string} origin - "members_list_scr"/"inv_members_scr"
 * @return {LogObject<addMemberSkipClickedParams>} LogObject<addMemberSkipClickedParams>
 */
export function addMemberSkipClicked(params) {
    return { evid: 27, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupGroupRulesCreateRuleClickIntent' event (evid: 28)
 *
 * Event description: Group ->  Group Rules - Create Rule Click (Intent)
 *
 * @param {groupGroupRulesCreateRuleClickIntentParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - create_rule_scr
 * @property {string} fromRuleTemplate - template name, number or other characteristics if from template, null if own rule (not from template)
 * @return {LogObject<groupGroupRulesCreateRuleClickIntentParams>} LogObject<groupGroupRulesCreateRuleClickIntentParams>
 */
export function groupGroupRulesCreateRuleClickIntent(params) {
    return { evid: 28, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupGroupRulesCreateRule' event (evid: 29)
 *
 * Event description: Group ->  Group Rules - Create Rule
 *
 * @param {groupGroupRulesCreateRuleParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} ruleDescription - rule description/ JSON
 * @property {string} origin - rule_description_scr
 * @property {number} ruleDescLength - count of characters in the description
 * @property {string} fromRuleTemplate - template characteristic if from template, null if own rule (not from template)
 * @property {string} ruleTitle - rule title / JSON
 * @return {LogObject<groupGroupRulesCreateRuleParams>} LogObject<groupGroupRulesCreateRuleParams>
 */
export function groupGroupRulesCreateRule(params) {
    return { evid: 29, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'postActionClick' event (evid: 3)
 *
 * Event description: user clicked post action from three dots
 *
 * @param {postActionClickParams} params - The parameters for this event
 * @property {GUID} group_id - group ID
 * @property {string} post_id - post_id
 * @property {string} container - groups/events
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - site
 * @property {string} userClass - owner/member
 * @property {string} postId - post_id
 * @property {string} origin - three_dots_menu
 * @property {string} action - 'delete'/'edit'/'share'/'follow'/'pin'
 * @return {LogObject<postActionClickParams>} LogObject<postActionClickParams>
 */
export function postActionClick(params) {
    return { evid: 3, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupEditSave' event (evid: 30)
 *
 * Event description: Group -> Edit -> Save
 *
 * @param {groupEditSaveParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - bizmngr / site / oneapp
 * @property {string} origin - group_edit_scr
 * @property {GUID} msid - msid
 * @return {LogObject<groupEditSaveParams>} LogObject<groupEditSaveParams>
 */
export function groupEditSave(params) {
    return { evid: 30, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupEditClose' event (evid: 31)
 *
 * Event description: Group -> Edit -> Save
 *
 * @param {groupEditCloseParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - bizmngr / site / oneapp
 * @property {string} origin - group_edit_scr
 * @property {GUID} msid - msid
 * @return {LogObject<groupEditCloseParams>} LogObject<groupEditCloseParams>
 */
export function groupEditClose(params) {
    return { evid: 31, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupEditAddEditCoverImage' event (evid: 32)
 *
 * Event description: Group - Edit - Add /Edit Cover Image
 *
 * @param {groupEditAddEditCoverImageParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - bizmngr / site / oneapp
 * @property {string} origin - group_edit_scr_add_img_btn/group_edit_scr_edit_btn
 * @property {GUID} msid - msid
 * @property {string} action - add/edit
 * @return {LogObject<groupEditAddEditCoverImageParams>} LogObject<groupEditAddEditCoverImageParams>
 */
export function groupEditAddEditCoverImage(params) {
    return { evid: 32, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsTemplatesClose' event (evid: 34)
 *
 * Event description: When user closes the Templates page
 *
 * @param {groupsTemplatesCloseParams} params - The parameters for this event
 * @property {string} origin - groups_templates_scr
 * @property {string} userEntry - bizmgr/site/editor/oneapp
 * @return {LogObject<groupsTemplatesCloseParams>} LogObject<groupsTemplatesCloseParams>
 */
export function groupsTemplatesClose(params) {
    return { evid: 34, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsTemplatesPageLoad' event (evid: 35)
 *
 * Event description: When user arrives at the Groups Templates page
 *
 * @param {groupsTemplatesPageLoadParams} params - The parameters for this event
 * @property {string} origin - groups_templates_scr
 * @property {string} userEntry - bizmgr/site/editor/oneapp
 * @return {LogObject<groupsTemplatesPageLoadParams>} LogObject<groupsTemplatesPageLoadParams>
 */
export function groupsTemplatesPageLoad(params) {
    return { evid: 35, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupGroupRulesRuleActions' event (evid: 36)
 *
 * Event description: Group ->  Group Rules - Rule Actions
 *
 * @param {groupGroupRulesRuleActionsParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - 1)details_tab_rule_area, 2)details_tab_edit_btn, 3)details_tab_delete_icon
 * @property {string} action - open/edit/delete
 * @return {LogObject<groupGroupRulesRuleActionsParams>} LogObject<groupGroupRulesRuleActionsParams>
 */
export function groupGroupRulesRuleActions(params) {
    return { evid: 36, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSelectGroupTemplateClick' event (evid: 37)
 *
 * Event description: Groups -> Select Group Template Click
 *
 * @param {groupsSelectGroupTemplateClickParams} params - The parameters for this event
 * @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
 * @property {string} userEntry - bizmgr/site/editor/oneapp
 * @property {string} templateId - template id
 * @property {string} origin - groups_templates_scr
 * @return {LogObject<groupsSelectGroupTemplateClickParams>} LogObject<groupsSelectGroupTemplateClickParams>
 */
export function groupsSelectGroupTemplateClick(params) {
    return { evid: 37, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupCreatePostClick' event (evid: 38)
 *
 * Event description: User clicked to create post
 *
 * @param {groupCreatePostClickParams} params - The parameters for this event
 * @property {string} button_name - photo/video/gif/share_something
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - site/preview
 * @property {string} origin - top_rce_area/media_tab_btn
 * @return {LogObject<groupCreatePostClickParams>} LogObject<groupCreatePostClickParams>
 */
export function groupCreatePostClick(params) {
    return { evid: 38, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSelectCommentTemplateClick' event (evid: 39)
 *
 * Event description: User clicked on comment template in Feed
 *
 * @param {groupsSelectCommentTemplateClickParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - site/preview/oneapp
 * @property {string} origin - feed_list/post
 * @property {string} template - template name
 * @property {string} type - template type
 * @return {LogObject<groupsSelectCommentTemplateClickParams>} LogObject<groupsSelectCommentTemplateClickParams>
 */
export function groupsSelectCommentTemplateClick(params) {
    return { evid: 39, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupActionClick' event (evid: 4)
 *
 * Event description: Clicked on Group action (from three dots)
 *
 * @param {groupActionClickParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} userEntry - site / bizmngr / null if wixapp
 * @property {string} origin - arrow / menu / button / modal_dialog_button
 * @property {string} action - 'share'/'group_settings'/'report'/'leave'/'delete'/'notification_settings'
 * @return {LogObject<groupActionClickParams>} LogObject<groupActionClickParams>
 */
export function groupActionClick(params) {
    return { evid: 4, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsReplyToCommentClick' event (evid: 40)
 *
 * Event description: User clicked on Reply to comment in Feed
 *
 * @param {groupsReplyToCommentClickParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - site/preview/oneapp
 * @property {string} origin - feed_list/post
 * @return {LogObject<groupsReplyToCommentClickParams>} LogObject<groupsReplyToCommentClickParams>
 */
export function groupsReplyToCommentClick(params) {
    return { evid: 40, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showMemberJoinUpdateToggle' event (evid: 41)
 *
 * Event description: Show Member Join Update Toggle
 *
 * @param {showMemberJoinUpdateToggleParams} params - The parameters for this event
 * @property {boolean} toggle - true/false
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - manage_group_updates_scr
 * @return {LogObject<showMemberJoinUpdateToggleParams>} LogObject<showMemberJoinUpdateToggleParams>
 */
export function showMemberJoinUpdateToggle(params) {
    return { evid: 41, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showGroupDetailsUpdateToggle' event (evid: 42)
 *
 * Event description: Show Group Details Update Toggle
 *
 * @param {showGroupDetailsUpdateToggleParams} params - The parameters for this event
 * @property {boolean} toggle - true/false
 * @property {string} userEntry - user_entry
 * @property {string} origin - origin
 * @return {LogObject<showGroupDetailsUpdateToggleParams>} LogObject<showGroupDetailsUpdateToggleParams>
 */
export function showGroupDetailsUpdateToggle(params) {
    return { evid: 42, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sendEmailDigestToggle' event (evid: 43)
 *
 * Event description: Send Email Digest Toggle
 *
 * @param {sendEmailDigestToggleParams} params - The parameters for this event
 * @property {string} digestToggle - enable/disable
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - groups_settings_screen
 * @return {LogObject<sendEmailDigestToggleParams>} LogObject<sendEmailDigestToggleParams>
 */
export function sendEmailDigestToggle(params) {
    return { evid: 43, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'moderationSettingsClicked' event (evid: 44)
 *
 * Event description: User clicks one of Moderation Settings buttons
 *
 * @param {moderationSettingsClickedParams} params - The parameters for this event
 * @property {string} groupId - group ID
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - groups_settings_screen
 * @property {string} settings - edit_permissions, 	membership_questions, 	manage_group_rules, 	manage_group_updates,
 * @return {LogObject<moderationSettingsClickedParams>} LogObject<moderationSettingsClickedParams>
 */
export function moderationSettingsClicked(params) {
    return { evid: 44, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupMembershipQuestionsAddQuestionClickIntent' event (evid: 45)
 *
 * Event description: Group ->  Membership Questions - Add Question Click (Intent)
 *
 * @param {groupMembershipQuestionsAddQuestionClickIntentParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - create_memb_question_scr_cta, memb_qs_scr_plus_btn
 * @return {LogObject<groupMembershipQuestionsAddQuestionClickIntentParams>} LogObject<groupMembershipQuestionsAddQuestionClickIntentParams>
 */
export function groupMembershipQuestionsAddQuestionClickIntent(params) {
    return { evid: 45, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupMembershipQuestionsCreateQuestion' event (evid: 46)
 *
 * Event description: Group ->  Membership Questions - Create Question.
 *
 * @param {groupMembershipQuestionsCreateQuestionParams} params - The parameters for this event
 * @property {number} questionLength - count of characters in the question
 * @property {string} questionId - question ID
 * @property {boolean} isRequired - true/false
 * @property {number} questionIndex - q index
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - add_question_scr
 * @property {string} questionText - question text/ JSON
 * @return {LogObject<groupMembershipQuestionsCreateQuestionParams>} LogObject<groupMembershipQuestionsCreateQuestionParams>
 */
export function groupMembershipQuestionsCreateQuestion(params) {
    return { evid: 46, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupMembershipQuestionsQuestionActions' event (evid: 47)
 *
 * Event description: Group ->  Membership Questions - Question Actions
 *
 * @param {groupMembershipQuestionsQuestionActionsParams} params - The parameters for this event
 * @property {string} questionId - question ID
 * @property {number} questionIndex - q index
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - edit_qs_scr_question_area, edit_qs_scr_three_dots, edit_question_modal, delete_question_modal
 * @property {string} action - open/edit/remove/delete/cancel
 * @return {LogObject<groupMembershipQuestionsQuestionActionsParams>} LogObject<groupMembershipQuestionsQuestionActionsParams>
 */
export function groupMembershipQuestionsQuestionActions(params) {
    return { evid: 47, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupMembershipQuestionsMembershipQuestionsScreenLoadForMember' event (evid: 48)
 *
 * Event description: Group ->  Membership Questions - Membership Questions Screen Load for Member
 *
 * @param {groupMembershipQuestionsMembershipQuestionsScreenLoadForMemberParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - member_questions_screen
 * @return {LogObject<groupMembershipQuestionsMembershipQuestionsScreenLoadForMemberParams>} LogObject<groupMembershipQuestionsMembershipQuestionsScreenLoadForMemberParams>
 */
export function groupMembershipQuestionsMembershipQuestionsScreenLoadForMember(params) {
    return { evid: 48, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupMembershipQuestionsMemberSubmitCloseAnswers' event (evid: 49)
 *
 * Event description: Group ->  Membership Questions - Member Submit/Close Answers
 *
 * @param {groupMembershipQuestionsMemberSubmitCloseAnswersParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - member_questions_screen
 * @property {string} action - submit/close
 * @property {number} countQuestions - (on submit) count of questions submitted
 * @return {LogObject<groupMembershipQuestionsMemberSubmitCloseAnswersParams>} LogObject<groupMembershipQuestionsMemberSubmitCloseAnswersParams>
 */
export function groupMembershipQuestionsMemberSubmitCloseAnswers(params) {
    return { evid: 49, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareGroupClick' event (evid: 5)
 *
 * Event description: clicked on share group
 *
 * @param {shareGroupClickParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} userEntry - site
 * @property {string} origin - share_dialog_modal
 * @property {string} type - 'facebook'/'twitter'/etc
 * @return {LogObject<shareGroupClickParams>} LogObject<shareGroupClickParams>
 */
export function shareGroupClick(params) {
    return { evid: 5, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupMembershipQuestionsOwnerViewAnswers' event (evid: 50)
 *
 * Event description: Group ->  Membership Questions - Owner View Answers
 *
 * @param {groupMembershipQuestionsOwnerViewAnswersParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - member_questions_screen
 * @property {string} memberUuid - member ID
 * @return {LogObject<groupMembershipQuestionsOwnerViewAnswersParams>} LogObject<groupMembershipQuestionsOwnerViewAnswersParams>
 */
export function groupMembershipQuestionsOwnerViewAnswers(params) {
    return { evid: 50, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsHeaderButtonClick' event (evid: 501)
 *
 * Event description: Header button click
 *
 * @param {groupsHeaderButtonClickParams} params - The parameters for this event
 * @property {string} user_entry - where the action was performed: BM/Editor
 * @property {string} button_name - CTA: create_group/create_post
 * @property {string} page_name - Location of the button: overview/topics
 * @property {string} group_id - Unique group identifier
 * @property {string} tab_name - Name of tab on the page
 * @property {string} details - Changes, if applied
 * @return {LogObject<groupsHeaderButtonClickParams>} LogObject<groupsHeaderButtonClickParams>
 */
export function groupsHeaderButtonClick(params) {
    return { evid: 501, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsListButtonClick' event (evid: 502)
 *
 * Event description: List button click
 *
 * @param {groupsListButtonClickParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} button_name - CTA: add_members/create_post
 * @property {string} page_name - Location of the button: overview/topics
 * @property {string} group_id - Unique group identifier
 * @property {string} tab_name - Where the action was performed: all_groups/created_by_me
 * @property {string} value - Value for params
 * @return {LogObject<groupsListButtonClickParams>} LogObject<groupsListButtonClickParams>
 */
export function groupsListButtonClick(params) {
    return { evid: 502, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsListCtaButtonClick' event (evid: 503)
 *
 * Event description: List CTA button click
 *
 * @param {groupsListCtaButtonClickParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} button_name - CTA: create_topic/create_post
 * @property {string} page_name - Location of the button: overview/topics
 * @property {string} group_id - Unique group identifier
 * @property {string} tabName - Where the action was performed: all_groups/created_by_me
 * @return {LogObject<groupsListCtaButtonClickParams>} LogObject<groupsListCtaButtonClickParams>
 */
export function groupsListCtaButtonClick(params) {
    return { evid: 503, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsExtraCardShown' event (evid: 504)
 *
 * Event description: Extra card shown
 *
 * @param {groupsExtraCardShownParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} page_name - Location of the card: overview/topics
 * @property {string} card_name - Card name/id
 * @property {number} completed_count - Number of completed CTAs
 * @return {LogObject<groupsExtraCardShownParams>} LogObject<groupsExtraCardShownParams>
 */
export function groupsExtraCardShown(params) {
    return { evid: 504, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsExtraCardCtaClick' event (evid: 505)
 *
 * Event description: Extra card CTA click
 *
 * @param {groupsExtraCardCtaClickParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} page_name - Location of the card: overview/topics
 * @property {string} card_name - Card name: automation/onboarding
 * @property {string} button_name - Action: manage_group/go_to_editor/create_post/
 * @return {LogObject<groupsExtraCardCtaClickParams>} LogObject<groupsExtraCardCtaClickParams>
 */
export function groupsExtraCardCtaClick(params) {
    return { evid: 505, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsExtraCardButtonClick' event (evid: 506)
 *
 * Event description: Extra card button click
 *
 * @param {groupsExtraCardButtonClickParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} page_name - Location of the card: overview/topics
 * @property {string} card_name - Card name: automation/onboarding
 * @property {string} button_name - Action: view_reports
 * @return {LogObject<groupsExtraCardButtonClickParams>} LogObject<groupsExtraCardButtonClickParams>
 */
export function groupsExtraCardButtonClick(params) {
    return { evid: 506, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsServiceButtonClick' event (evid: 507)
 *
 * Event description: Service button click
 *
 * @param {groupsServiceButtonClickParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} page_name - Location of the button: overview/topics
 * @property {string} button_name - Button name: filter/search/sort
 * @property {string} parameter - Entered param: latest, name
 * @return {LogObject<groupsServiceButtonClickParams>} LogObject<groupsServiceButtonClickParams>
 */
export function groupsServiceButtonClick(params) {
    return { evid: 507, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsModalButtonClick' event (evid: 508)
 *
 * Event description: Modal button click
 *
 *
 * @param {groupsModalButtonClickParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} page_name - Location of the button: overview/topics
 * @property {string} origin - Where the modal was called from
 * @property {string} button_name - Action: send_email/add_members/save/cancel
 * @property {string} parameter - Selection item: group_id/null
 * @property {string} modal_name - Name of the model called: add_all_members_confirm/add_members_confirm
 * @property {string} group_id - Unique identifier of the group
 * @property {string} step - If modal calls modal - add number
 * @property {string} user_role - Owner / uou
 * @return {LogObject<groupsModalButtonClickParams>} LogObject<groupsModalButtonClickParams>
 */
export function groupsModalButtonClick(params) {
    return { evid: 508, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsListClick' event (evid: 509)
 *
 * Event description: List click
 *
 * @param {groupsListClickParams} params - The parameters for this event
 * @property {string} user_entry - Where the action was performed: BM/Editor
 * @property {string} page_name - Location of the button: overview/topics
 * @property {string} group_id - Unique group identifier
 * @property {string} tab_name - Where the action was performed: all_groups/created_by_me
 * @property {string} member_id - Unique member identifier
 * @return {LogObject<groupsListClickParams>} LogObject<groupsListClickParams>
 */
export function groupsListClick(params) {
    return { evid: 509, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsNotificationShownSrc111Evid510' event (evid: 510)
 *
 * Event description: Error or success notification
 *
 * @param {groupsNotificationShownSrc111Evid510Params} params - The parameters for this event
 * @property {string} type - Type: error or success
 * @property {string} name - Definition of error
 * @property {string} page_name - Where the error occurred
 * @property {string} user_entry - User entry
 * @property {string} group_id - Unqiue identifier of group
 * @return {LogObject<groupsNotificationShownSrc111Evid510Params>} LogObject<groupsNotificationShownSrc111Evid510Params>
 */
export function groupsNotificationShownSrc111Evid510(params) {
    return { evid: 510, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsBmPageLoadedSrc111Evid511' event (evid: 511)
 *
 * Event description: Groups: BM page loaded
 *
 * @param {groupsBmPageLoadedSrc111Evid511Params} params - The parameters for this event
 * @property {string} userEntry - BM
 * @property {string} pageName - info, overview
 * @property {string} groupId - unique identifier of the group
 * @property {string} loadStatus - loaded/not_loaded
 * @property {boolean} is_empty - if there is content on the page
 * @return {LogObject<groupsBmPageLoadedSrc111Evid511Params>} LogObject<groupsBmPageLoadedSrc111Evid511Params>
 */
export function groupsBmPageLoadedSrc111Evid511(params) {
    return { evid: 511, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupMembershipQuestionsMembershipQuestionsSaved' event (evid: 52)
 *
 * Event description: Group ->  Membership Questions - Membership Questions Saved
 *
 * @param {groupMembershipQuestionsMembershipQuestionsSavedParams} params - The parameters for this event
 * @property {string} questionsArray - JSON with all questions and is_required attribute
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - user_entry
 * @property {string} origin - add_question_scr
 * @property {number} countQuestions - count_questions
 * @return {LogObject<groupMembershipQuestionsMembershipQuestionsSavedParams>} LogObject<groupMembershipQuestionsMembershipQuestionsSavedParams>
 */
export function groupMembershipQuestionsMembershipQuestionsSaved(params) {
    return { evid: 52, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchOpenSearchSrc111Evid521' event (evid: 521)
 *
 * Event description: Click on the search icon
 *
 * @param {groupsSearchOpenSearchSrc111Evid521Params} params - The parameters for this event
 * @property {string} origin - where search is called from
 * @property {string} groupId - unique identifier of the group
 * @property {GUID} msid - unique identifier of site
 * @property {GUID} visitor_id - unique identifier of visitor
 * @property {string} client_id - unique identifier of anonymous  visitor
 * @return {LogObject<groupsSearchOpenSearchSrc111Evid521Params>} LogObject<groupsSearchOpenSearchSrc111Evid521Params>
 */
export function groupsSearchOpenSearchSrc111Evid521(params) {
    return { evid: 521, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchSearchRequestSrc111Evid522' event (evid: 522)
 *
 * Event description: User's search request details
 *
 * @param {groupsSearchSearchRequestSrc111Evid522Params} params - The parameters for this event
 * @property {string} origin - where search is called from
 * @property {string} groupId - unique identifier of the group
 * @property {string} tabName - type of content for search
 * @property {string} inputText - user's request
 * @property {GUID} msid - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} client_id - client_id
 * @return {LogObject<groupsSearchSearchRequestSrc111Evid522Params>} LogObject<groupsSearchSearchRequestSrc111Evid522Params>
 */
export function groupsSearchSearchRequestSrc111Evid522(params) {
    return { evid: 522, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchSearchResultSrc111Evid523' event (evid: 523)
 *
 * Event description: User's search result details
 *
 * @param {groupsSearchSearchResultSrc111Evid523Params} params - The parameters for this event
 * @property {string} origin - where search is called from
 * @property {string} groupId - unique identifier of the group
 * @property {string} tabName - type of content for search
 * @property {string} responseStatus - status or response
 * @property {string} outputJson - json with results
 * @property {string} inputText - user's request
 * @property {GUID} msid - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} client_id - client_id
 * @return {LogObject<groupsSearchSearchResultSrc111Evid523Params>} LogObject<groupsSearchSearchResultSrc111Evid523Params>
 */
export function groupsSearchSearchResultSrc111Evid523(params) {
    return { evid: 523, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'searchTabClickSrc111Evid524' event (evid: 524)
 *
 * Event description: click on tabs inside search
 *
 * @param {searchTabClickSrc111Evid524Params} params - The parameters for this event
 * @property {string} tab_name - tab_name: posts, groups
 * @property {string} origin - origin: group_page, group_list, central_feed, horizontal_group_list
 * @property {string} group_id - group_id: null if origin != group_page
 * @property {GUID} msid - msid
 * @property {GUID} visitor_id - visitor id
 * @property {GUID} client_id - client id
 * @return {LogObject<searchTabClickSrc111Evid524Params>} LogObject<searchTabClickSrc111Evid524Params>
 */
export function searchTabClickSrc111Evid524(params) {
    return { evid: 524, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchSearchResultClickSrc111Evid525' event (evid: 525)
 *
 * Event description: User's click on search result
 *
 * @param {groupsSearchSearchResultClickSrc111Evid525Params} params - The parameters for this event
 * @property {string} origin - where search is called from
 * @property {string} groupId - unique identifier of the group
 * @property {string} tabName - type of content for search
 * @property {string} outputJson - json with results
 * @property {string} inputText - user's request
 * @property {GUID} msid - msid
 * @property {GUID} visitor_id - visitor id
 * @property {string} client_id - client id
 * @return {LogObject<groupsSearchSearchResultClickSrc111Evid525Params>} LogObject<groupsSearchSearchResultClickSrc111Evid525Params>
 */
export function groupsSearchSearchResultClickSrc111Evid525(params) {
    return { evid: 525, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSendLinkToGetGroupsOnWebClicked' event (evid: 53)
 *
 * Event description: Groups - Send Link to Get Groups on Web Clicked
 *
 * @param {groupsSendLinkToGetGroupsOnWebClickedParams} params - The parameters for this event
 * @property {string} userEntry - oneapp
 * @property {string} origin - groups_list_scr / get_web_link_scr
 * @property {string} action - learn_more/send_link/close
 * @return {LogObject<groupsSendLinkToGetGroupsOnWebClickedParams>} LogObject<groupsSendLinkToGetGroupsOnWebClickedParams>
 */
export function groupsSendLinkToGetGroupsOnWebClicked(params) {
    return { evid: 53, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'memberPermissionsEditClickSrc111Evid530' event (evid: 530)
 *
 * Event description: Edit settings on livesite
 *
 * @param {memberPermissionsEditClickSrc111Evid530Params} params - The parameters for this event
 * @property {string} setting_name - Questions/Permissions
 * @return {LogObject<memberPermissionsEditClickSrc111Evid530Params>} LogObject<memberPermissionsEditClickSrc111Evid530Params>
 */
export function memberPermissionsEditClickSrc111Evid530(params) {
    return { evid: 530, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'memberPermissionsEditSaveSrc111Evid531' event (evid: 531)
 *
 * Event description: Save settings on livesite
 *
 * @param {memberPermissionsEditSaveSrc111Evid531Params} params - The parameters for this event
 * @property {string} settings_changed - json with question_name as a key and true/false as value
 * @property {number} questions_added - count of added questions
 * @return {LogObject<memberPermissionsEditSaveSrc111Evid531Params>} LogObject<memberPermissionsEditSaveSrc111Evid531Params>
 */
export function memberPermissionsEditSaveSrc111Evid531(params) {
    return { evid: 531, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingViewSrc111Evid532' event (evid: 532)
 *
 * Event description: view of onboarding
 *
 * @param {onboardingViewSrc111Evid532Params} params - The parameters for this event
 * @property {string} user_role - owner/uou
 * @property {string} group_id - group id
 * @property {number} total_steps - number of steps
 * @property {number} completed_steps_cnt - number of completed steps
 * @property {string} steps_list - json with steps' status
 * @return {LogObject<onboardingViewSrc111Evid532Params>} LogObject<onboardingViewSrc111Evid532Params>
 */
export function onboardingViewSrc111Evid532(params) {
    return { evid: 532, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingClickSrc111Evid533' event (evid: 533)
 *
 * Event description: click on onboarding CTA
 *
 * @param {onboardingClickSrc111Evid533Params} params - The parameters for this event
 * @property {string} user_role - owner/uou
 * @property {string} group_id - group id
 * @property {number} total_steps - number of steps
 * @property {number} completed_steps_cnt - number of completed steps
 * @property {string} steps_list - json with steps' status
 * @property {string} step - step name
 * @return {LogObject<onboardingClickSrc111Evid533Params>} LogObject<onboardingClickSrc111Evid533Params>
 */
export function onboardingClickSrc111Evid533(params) {
    return { evid: 533, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupNotificationsSettingsSave' event (evid: 54)
 *
 * Event description: Saves new Notifications settings
 *
 * @param {groupNotificationsSettingsSaveParams} params - The parameters for this event
 * @property {boolean} posts - bool
 * @property {boolean} reactions - bool
 * @property {boolean} groupUpdates - bool
 * @property {boolean} websiteToggle - bool
 * @property {string} tabName - website/email/mobile_app
 * @property {GUID} groupId - id
 * @property {string} userEntry - site
 * @property {boolean} newMembers - bool
 * @property {boolean} membersJoined - bool
 * @property {string} origin - save_btn
 * @property {boolean} mobileAppToggle - bool
 * @property {boolean} emailToggle - bool
 * @property {boolean} comments - bool
 * @return {LogObject<groupNotificationsSettingsSaveParams>} LogObject<groupNotificationsSettingsSaveParams>
 */
export function groupNotificationsSettingsSave(params) {
    return { evid: 54, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsForumViewSrc111Evid540' event (evid: 540)
 *
 * Event description: View of main elements in forum 2 groups migration
 *
 * @param {groupsForumViewSrc111Evid540Params} params - The parameters for this event
 * @property {string} view_name - promote, modal, forum_switched_off, migration_widget
 * @property {string} completed_steps - number of ready steps
 * @return {LogObject<groupsForumViewSrc111Evid540Params>} LogObject<groupsForumViewSrc111Evid540Params>
 */
export function groupsForumViewSrc111Evid540(params) {
    return { evid: 540, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsForumClickSrc111Evid541' event (evid: 541)
 *
 * Event description: Click on main elements in forum 2 groups migration
 *
 * @param {groupsForumClickSrc111Evid541Params} params - The parameters for this event
 * @property {string} view_name - promote, modal, forum_switched_off, migration_widget
 * @property {string} button_name - move_forum, learn_more, move_now, maybe_later, move_to_editor, add_members
 * @return {LogObject<groupsForumClickSrc111Evid541Params>} LogObject<groupsForumClickSrc111Evid541Params>
 */
export function groupsForumClickSrc111Evid541(params) {
    return { evid: 541, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsForumClickCopySrc111Evid542' event (evid: 542)
 *
 * Event description: Errors in forum 2 groups migration
 *
 * @param {groupsForumClickCopySrc111Evid542Params} params - The parameters for this event
 * @property {string} name - add_members, import_content
 * @return {LogObject<groupsForumClickCopySrc111Evid542Params>} LogObject<groupsForumClickCopySrc111Evid542Params>
 */
export function groupsForumClickCopySrc111Evid542(params) {
    return { evid: 542, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsWelcomeToGroupsScreenLoad' event (evid: 55)
 *
 * Event description: Groups - Welcome to Groups Screen Load.
 *
 * @param {groupsWelcomeToGroupsScreenLoadParams} params - The parameters for this event
 * @property {string} userEntry - oneapp
 * @return {LogObject<groupsWelcomeToGroupsScreenLoadParams>} LogObject<groupsWelcomeToGroupsScreenLoadParams>
 */
export function groupsWelcomeToGroupsScreenLoad(params) {
    return { evid: 55, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsCreateSave' event (evid: 557)
 *
 * Event description: Groups -> Create -> Save.
 *
 * @param {groupsCreateSaveParams} params - The parameters for this event
 * @property {number} countMembersAdded - count_members_added
 * @property {string} origin - origin
 * @property {string} type - type
 * @property {boolean} withPhoto - with_photo
 * @return {LogObject<groupsCreateSaveParams>} LogObject<groupsCreateSaveParams>
 */
export function groupsCreateSave(params) {
    return { evid: 557, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsTabClicked' event (evid: 558)
 *
 * Event description: When a user clicks on a tab in the group view
 *
 * @param {groupsTabClickedParams} params - The parameters for this event
 * @property {GUID} group_id - group ID
 * @property {string} name - tab name
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - site
 * @property {string} origin - tabs / see_all_members_link / pinned_window
 * @return {LogObject<groupsTabClickedParams>} LogObject<groupsTabClickedParams>
 */
export function groupsTabClicked(params) {
    return { evid: 558, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsAboutEditClicked' event (evid: 559)
 *
 * Event description: Group - Description - Edit clicked.
 *
 * @param {groupsAboutEditClickedParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - site / bizmngr
 * @property {string} userClass - owner/member
 * @property {string} origin - edit_descr_link
 * @return {LogObject<groupsAboutEditClickedParams>} LogObject<groupsAboutEditClickedParams>
 */
export function groupsAboutEditClicked(params) {
    return { evid: 559, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsWelcomeToGroupsScreenClick' event (evid: 56)
 *
 * Event description: Groups - Welcome to Groups Screen Click
 *
 * @param {groupsWelcomeToGroupsScreenClickParams} params - The parameters for this event
 * @property {string} action - get_started/back
 * @property {string} userEntry - oneapp
 * @return {LogObject<groupsWelcomeToGroupsScreenClickParams>} LogObject<groupsWelcomeToGroupsScreenClickParams>
 */
export function groupsWelcomeToGroupsScreenClick(params) {
    return { evid: 56, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsAboutEditSave' event (evid: 560)
 *
 * Event description: Group - Description - Edit Save.
 *
 * @param {groupsAboutEditSaveParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - site / bizmngr
 * @property {string} origin - modal_scrn_save_btn
 * @property {number} length - length
 * @return {LogObject<groupsAboutEditSaveParams>} LogObject<groupsAboutEditSaveParams>
 */
export function groupsAboutEditSave(params) {
    return { evid: 560, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsActionClicked' event (evid: 563)
 *
 * Event description: Group -> Group Settings/Manage Action Clicked
 *
 * @param {groupsActionClickedParams} params - The parameters for this event
 * @property {string} name - name of the action: show/hide/manage/rename/delete
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - oneapp/bizmngr/site
 * @property {string} origin - where click happened: example - group_custom_tab_settings
 * @property {GUID} msid - msid
 * @return {LogObject<groupsActionClickedParams>} LogObject<groupsActionClickedParams>
 */
export function groupsActionClicked(params) {
    return { evid: 563, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsRequestJoinAGroup' event (evid: 564)
 *
 * Event description: Groups -> request / join a group.
 *
 * @param {groupsRequestJoinAGroupParams} params - The parameters for this event
 * @property {GUID} groupId - value
 * @property {GUID} group_id - value
 * @property {string} userEntry - site / bizmngr
 * @property {string} origin - group_feed_top_banner_btn / group_feed_inside_page_btn
 * @property {string} type - type
 * @property {string} approvalStatus - status of member upon request
 * @return {LogObject<groupsRequestJoinAGroupParams>} LogObject<groupsRequestJoinAGroupParams>
 */
export function groupsRequestJoinAGroup(params) {
    return { evid: 564, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSelectGroupFromList' event (evid: 566)
 *
 * Event description: Groups -> Open Group.
 *
 * @param {groupsSelectGroupFromListParams} params - The parameters for this event
 * @property {string} container - container
 * @property {string} componentName - (for web) groups / groups_list_widget
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - bizmgr/site/members_area/oneapp
 * @property {string} origin - view_btn / group_title / group_image / group_block / groups_my_group_tab_view_btn
 * @property {string} pageName - (for web) from which page click was made
 * @return {LogObject<groupsSelectGroupFromListParams>} LogObject<groupsSelectGroupFromListParams>
 */
export function groupsSelectGroupFromList(params) {
    return { evid: 566, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsEditClicked' event (evid: 568)
 *
 * Event description: Groups -> edit clicked.
 *
 * @param {groupsEditClickedParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - bizmngr / site / oneapp
 * @property {string} origin - group settings / onboarding
 * @return {LogObject<groupsEditClickedParams>} LogObject<groupsEditClickedParams>
 */
export function groupsEditClicked(params) {
    return { evid: 568, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsAddMemberClicked' event (evid: 569)
 *
 * Event description: Groups -> add member clicked.
 *
 * @param {groupsAddMemberClickedParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/site/bizmngr
 * @property {string} origin - origin
 * @property {string} pageName - name of initiating page on the site
 * @return {LogObject<groupsAddMemberClickedParams>} LogObject<groupsAddMemberClickedParams>
 */
export function groupsAddMemberClicked(params) {
    return { evid: 569, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupViewPrivateMembersList' event (evid: 57)
 *
 * Event description: Group -> View Private Members List
 *
 * @param {groupViewPrivateMembersListParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr/site
 * @property {string} origin - memebrs_list_scr
 * @return {LogObject<groupViewPrivateMembersListParams>} LogObject<groupViewPrivateMembersListParams>
 */
export function groupViewPrivateMembersList(params) {
    return { evid: 57, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSelectAllMembersClicked' event (evid: 570)
 *
 * Event description: Groups -> Select All Members Clicked
 *
 * @param {groupsSelectAllMembersClickedParams} params - The parameters for this event
 * @property {number} count - count of selected Members
 * @property {string} membersType - private/public
 * @property {GUID} groupId - Group ID
 * @property {string} userEntry - oneapp/site/bizmngr
 * @property {string} origin - 'members_list_scr'
 * @property {string} action - select/unselect
 * @return {LogObject<groupsSelectAllMembersClickedParams>} LogObject<groupsSelectAllMembersClickedParams>
 */
export function groupsSelectAllMembersClicked(params) {
    return { evid: 570, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsAddMemberClickDone' event (evid: 571)
 *
 * Event description: Group -> Add Member -> Click Done.
 *
 * @param {groupsAddMemberClickDoneParams} params - The parameters for this event
 * @property {number} count - number of members added
 * @property {string} membersType - private/public
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {boolean} selectAll - true/false
 * @property {string} origin - 'members_list_scr'
 * @return {LogObject<groupsAddMemberClickDoneParams>} LogObject<groupsAddMemberClickDoneParams>
 */
export function groupsAddMemberClickDone(params) {
    return { evid: 571, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupSettingsSelectSettingsAreaFromList' event (evid: 572)
 *
 * Event description: Group -> Settings -> Select Settings area from list.
 *
 * @param {groupSettingsSelectSettingsAreaFromListParams} params - The parameters for this event
 * @property {string} name - Settings area name
 * @property {GUID} groupId - group ID
 * @property {string} origin - manage_tab/ null for add_on settings
 * @return {LogObject<groupSettingsSelectSettingsAreaFromListParams>} LogObject<groupSettingsSelectSettingsAreaFromListParams>
 */
export function groupSettingsSelectSettingsAreaFromList(params) {
    return { evid: 572, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsRenameTabClickSave' event (evid: 573)
 *
 * Event description: Groups -> rename tab -> click save.
 *
 * @param {groupsRenameTabClickSaveParams} params - The parameters for this event
 * @property {string} name - name
 * @property {GUID} groupId - group_id
 * @return {LogObject<groupsRenameTabClickSaveParams>} LogObject<groupsRenameTabClickSaveParams>
 */
export function groupsRenameTabClickSave(params) {
    return { evid: 573, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsMemberClickOnThreeDots' event (evid: 574)
 *
 * Event description: Groups -> member -> click on three dots.
 *
 * @param {groupsMemberClickOnThreeDotsParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} memberUuid - member_uuid
 * @property {GUID} memberId - member_id
 * @return {LogObject<groupsMemberClickOnThreeDotsParams>} LogObject<groupsMemberClickOnThreeDotsParams>
 */
export function groupsMemberClickOnThreeDots(params) {
    return { evid: 574, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsMemberRequestApproveDecline' event (evid: 576)
 *
 * Event description: Groups -> member request -> approve / decline.
 *
 * @param {groupsMemberRequestApproveDeclineParams} params - The parameters for this event
 * @property {string} groupId - group id or array
 * @property {string} userEntry - bizmgr/site/members_area/oneapp
 * @property {string} origin - user_lvl_btn
 * @property {string} memberUuid - member uuid or array
 * @property {GUID} memberId - member id or array
 * @property {boolean} isAll - is_all
 * @property {string} type - type
 * @return {LogObject<groupsMemberRequestApproveDeclineParams>} LogObject<groupsMemberRequestApproveDeclineParams>
 */
export function groupsMemberRequestApproveDecline(params) {
    return { evid: 576, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupGroupEventsButtonClicks' event (evid: 58)
 *
 * Event description: Group -> Group Events Button Clicks
 *
 * @param {groupGroupEventsButtonClicksParams} params - The parameters for this event
 * @property {string} name - Settings area name
 * @property {number} count - # of events with checks on “save”
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - oneapp/bizmngr/site
 * @property {string} origin - group_events_list, group_events_empty_state
 * @property {string} buttonName - create_event, discard/back, save
 * @return {LogObject<groupGroupEventsButtonClicksParams>} LogObject<groupGroupEventsButtonClicksParams>
 */
export function groupGroupEventsButtonClicks(params) {
    return { evid: 58, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchMembersClick' event (evid: 59)
 *
 * Event description: Groups -> Search Members Click
 *
 * @param {groupsSearchMembersClickParams} params - The parameters for this event
 * @property {string} membersType - private/public
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - 'members_list_scr'
 * @return {LogObject<groupsSearchMembersClickParams>} LogObject<groupsSearchMembersClickParams>
 */
export function groupsSearchMembersClick(params) {
    return { evid: 59, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'leaveGroupClick' event (evid: 6)
 *
 * Event description: user left group
 *
 * @param {leaveGroupClickParams} params - The parameters for this event
 * @property {GUID} group_id - group
 * @property {string} userEntry - site
 * @property {string} origin - leave_dialog_modal
 * @return {LogObject<leaveGroupClickParams>} LogObject<leaveGroupClickParams>
 */
export function leaveGroupClick(params) {
    return { evid: 6, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSelectMemberInMembersList' event (evid: 60)
 *
 * Event description: Groups -> Select Member in Members List
 *
 * @param {groupsSelectMemberInMembersListParams} params - The parameters for this event
 * @property {string} membersType - private/public
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - 'members_list_scr'
 * @return {LogObject<groupsSelectMemberInMembersListParams>} LogObject<groupsSelectMemberInMembersListParams>
 */
export function groupsSelectMemberInMembersList(params) {
    return { evid: 60, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsPermisionForUouToCreateAGroup' event (evid: 604)
 *
 * Event description: Groups -> permision for UoU to create a group.
 *
 * @param {groupsPermisionForUouToCreateAGroupParams} params - The parameters for this event
 * @property {boolean} toggle - toggle
 * @property {string} permissions - members/owner_only/members_with_approval
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - save_btn
 * @return {LogObject<groupsPermisionForUouToCreateAGroupParams>} LogObject<groupsPermisionForUouToCreateAGroupParams>
 */
export function groupsPermisionForUouToCreateAGroup(params) {
    return { evid: 604, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedTopicsAddTopicClickIntent' event (evid: 61)
 *
 * Event description: Group ->  Feed Topics - Add Topic Click (Intent)
 *
 * @param {groupFeedTopicsAddTopicClickIntentParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - feed_topics_scr_cta
 * @return {LogObject<groupFeedTopicsAddTopicClickIntentParams>} LogObject<groupFeedTopicsAddTopicClickIntentParams>
 */
export function groupFeedTopicsAddTopicClickIntent(params) {
    return { evid: 61, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedTopicsCreateTopic' event (evid: 62)
 *
 * Event description: Group ->  Feed Topics - Create Topic
 *
 * @param {groupFeedTopicsCreateTopicParams} params - The parameters for this event
 * @property {string} topicId - topic ID
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {number} topicLength - count of characters in the topic name
 * @property {string} origin - add_question_scr
 * @property {string} topicName - topic name/ JSON
 * @return {LogObject<groupFeedTopicsCreateTopicParams>} LogObject<groupFeedTopicsCreateTopicParams>
 */
export function groupFeedTopicsCreateTopic(params) {
    return { evid: 62, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchTabClickSrc111Evid624' event (evid: 624)
 *
 * Event description: Click on the content type tab
 *
 * @param {groupsSearchTabClickSrc111Evid624Params} params - The parameters for this event
 * @property {string} origin - where search is called from
 * @property {string} groupId - unique identifier of the group
 * @property {string} tabName - type of content for search
 * @return {LogObject<groupsSearchTabClickSrc111Evid624Params>} LogObject<groupsSearchTabClickSrc111Evid624Params>
 */
export function groupsSearchTabClickSrc111Evid624(params) {
    return { evid: 624, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedTopicsTopicActions' event (evid: 63)
 *
 * Event description: Group ->  Feed Topics - Topic Actions
 *
 * @param {groupFeedTopicsTopicActionsParams} params - The parameters for this event
 * @property {string} topicId - topic ID
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - feed_topic_area, edit_qs_scr_three_dots, edit_topic_modal, delete_topic_modal
 * @property {string} topicName - topic title
 * @property {string} action - open/edit/remove/delete/cancel
 * @return {LogObject<groupFeedTopicsTopicActionsParams>} LogObject<groupFeedTopicsTopicActionsParams>
 */
export function groupFeedTopicsTopicActions(params) {
    return { evid: 63, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedTopicsSelectTopicInFeed' event (evid: 64)
 *
 * Event description: Group ->  Feed Topics - Select Topic in Feed
 *
 * @param {groupFeedTopicsSelectTopicInFeedParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} postId - ID of the post with topic
 * @property {string} origin - add_question_scr
 * @return {LogObject<groupFeedTopicsSelectTopicInFeedParams>} LogObject<groupFeedTopicsSelectTopicInFeedParams>
 */
export function groupFeedTopicsSelectTopicInFeed(params) {
    return { evid: 64, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedTopicsAddTopicToPost' event (evid: 65)
 *
 * Event description: Group ->  Feed Topics - Add Topic To Post
 *
 * @param {groupFeedTopicsAddTopicToPostParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} postId - ID of the post with topic
 * @property {string} origin - add_question_scr
 * @property {string} topicName - topic name
 * @return {LogObject<groupFeedTopicsAddTopicToPostParams>} LogObject<groupFeedTopicsAddTopicToPostParams>
 */
export function groupFeedTopicsAddTopicToPost(params) {
    return { evid: 65, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showMemberListToggle' event (evid: 66)
 *
 * Event description: Show Member List to all Groups Members Toggle
 *
 * @param {showMemberListToggleParams} params - The parameters for this event
 * @property {boolean} toggle - true/false
 * @property {string} userEntry - oneapp
 * @property {string} origin - member_list_settings_scr
 * @return {LogObject<showMemberListToggleParams>} LogObject<showMemberListToggleParams>
 */
export function showMemberListToggle(params) {
    return { evid: 66, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsIntegrationSelectWhichGroupToConnect' event (evid: 67)
 *
 * Event description: When user clicks on groups list to select which group to connect to challenge etc.
 *
 * @param {groupsIntegrationSelectWhichGroupToConnectParams} params - The parameters for this event
 * @property {string} container - connect/create group
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - bizmgr/site/members_area/oneapp
 * @property {string} ppID - paid plan id
 * @property {string} origin - group list
 * @property {GUID} event_id - ID
 * @return {LogObject<groupsIntegrationSelectWhichGroupToConnectParams>} LogObject<groupsIntegrationSelectWhichGroupToConnectParams>
 */
export function groupsIntegrationSelectWhichGroupToConnect(params) {
    return { evid: 67, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSharePost' event (evid: 678)
 *
 * Event description: Groups -> Share Post.
 *
 * @param {groupsSharePostParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} post_id - post_id
 * @property {string} userClass - user_class
 * @property {string} origin - origin
 * @return {LogObject<groupsSharePostParams>} LogObject<groupsSharePostParams>
 */
export function groupsSharePost(params) {
    return { evid: 678, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsFeedInviteMembers' event (evid: 679)
 *
 * Event description: The event is triggered when a user presses the share button (either from the share button or the post header) in the groups feed.
 *
 * @param {groupsFeedInviteMembersParams} params - The parameters for this event
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - oneapp/bizmngr/site
 * @property {string} userClass - owner/member
 * @property {string} origin - groups onboarding
 * @return {LogObject<groupsFeedInviteMembersParams>} LogObject<groupsFeedInviteMembersParams>
 */
export function groupsFeedInviteMembers(params) {
    return { evid: 679, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupAddCustomTabContent' event (evid: 68)
 *
 * Event description: Group -> Add/Edit Custom Tab Content clicked
 *
 * @param {groupAddCustomTabContentParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr/live site
 * @property {string} origin - click origin, example add_content_plus_btn
 * @property {string} isContentEmpty - true/false
 * @return {LogObject<groupAddCustomTabContentParams>} LogObject<groupAddCustomTabContentParams>
 */
export function groupAddCustomTabContent(params) {
    return { evid: 68, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupCustomTabSave' event (evid: 69)
 *
 * Event description: Group ->  Custom Tab Save Clicked
 *
 * @param {groupCustomTabSaveParams} params - The parameters for this event
 * @property {number} imgCnt - number of images
 * @property {number} videosCnt - number of videos
 * @property {number} filesCnt - number of files
 * @property {number} linksCnt - number of links
 * @property {string} tabName - tab name
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} tabDescription - tab description (full text)
 * @return {LogObject<groupCustomTabSaveParams>} LogObject<groupCustomTabSaveParams>
 */
export function groupCustomTabSave(params) {
    return { evid: 69, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'memberWelcomeScreenSeeMoreClicked' event (evid: 698)
 *
 * Event description: Member Welcome Screen - See More Clicked.
 *
 * @param {memberWelcomeScreenSeeMoreClickedParams} params - The parameters for this event
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - wixapp/site
 * @return {LogObject<memberWelcomeScreenSeeMoreClickedParams>} LogObject<memberWelcomeScreenSeeMoreClickedParams>
 */
export function memberWelcomeScreenSeeMoreClicked(params) {
    return { evid: 698, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupEditGroupDescription' event (evid: 70)
 *
 * Event description: Group Post -> options -> Report action from Report modal (Report/Cancel)
 *
 * @param {groupEditGroupDescriptionParams} params - The parameters for this event
 * @property {string} container - groups/ events
 * @property {GUID} groupId - group ID
 * @property {string} userClass - owner / member
 * @property {GUID} postId - post ID
 * @property {string} action - report / cancel
 * @return {LogObject<groupEditGroupDescriptionParams>} LogObject<groupEditGroupDescriptionParams>
 */
export function groupEditGroupDescription(params) {
    return { evid: 70, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupOnboardingAction' event (evid: 71)
 *
 * Event description: Group -> Onboarding Action
 *
 * @param {groupOnboardingActionParams} params - The parameters for this event
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
 * @property {boolean} withPimple - true/false
 * @property {string} action - close/progress_click/invite/add_cover/update_descr/create_post
 * @return {LogObject<groupOnboardingActionParams>} LogObject<groupOnboardingActionParams>
 */
export function groupOnboardingAction(params) {
    return { evid: 71, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedTopicsTopicListActions' event (evid: 72)
 *
 * Event description: Group ->  Feed Topics - Topic List Actions (Sort, Search, Select)
 *
 * @param {groupFeedTopicsTopicListActionsParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - oneapp/bizmngr
 * @property {string} origin - topic_list
 * @property {string} action - sort_recent/sort_name/sort_posts, search, select_all -> delete
 * @return {LogObject<groupFeedTopicsTopicListActionsParams>} LogObject<groupFeedTopicsTopicListActionsParams>
 */
export function groupFeedTopicsTopicListActions(params) {
    return { evid: 72, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsNewAboutSeeAllMembers' event (evid: 721)
 *
 * Event description: Groups-> New about- see all members.
 *
 * @param {groupsNewAboutSeeAllMembersParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} role - role
 * @property {GUID} uuid - uuid
 * @property {string} roles - user_roles
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<groupsNewAboutSeeAllMembersParams>} LogObject<groupsNewAboutSeeAllMembersParams>
 */
export function groupsNewAboutSeeAllMembers(params) {
    return { evid: 721, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupTabsSettingsSave' event (evid: 727)
 *
 * Event description: Group Tabs Settings -> Save clicked
 *
 * @param {groupTabsSettingsSaveParams} params - The parameters for this event
 * @property {GUID} groupId - group_id
 * @property {string} userEntry - user_entry
 * @property {string} tabOrder - tab order, i.e: "discussion, media, about, etc."
 * @return {LogObject<groupTabsSettingsSaveParams>} LogObject<groupTabsSettingsSaveParams>
 */
export function groupTabsSettingsSave(params) {
    return { evid: 727, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupInviteMembersOptionClicked' event (evid: 74)
 *
 * Event description: Group -> Add/Invite Members Option Clicked
 *
 * @param {groupInviteMembersOptionClickedParams} params - The parameters for this event
 * @property {GUID} groupId - group ID
 * @property {string} optionType - selected option - send_email, add_site_members, copy_link, create_email_campaign
 * @property {string} userEntry - oneapp/site/bizmngr
 * @property {string} origin - invite_modal
 * @return {LogObject<groupInviteMembersOptionClickedParams>} LogObject<groupInviteMembersOptionClickedParams>
 */
export function groupInviteMembersOptionClicked(params) {
    return { evid: 74, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsManageTabsWixApp' event (evid: 753)
 *
 * Event description: Groups -> Manage Tabs - WixApp.
 *
 * @param {groupsManageTabsWixAppParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} name - tab name
 * @property {GUID} msid - msid
 * @return {LogObject<groupsManageTabsWixAppParams>} LogObject<groupsManageTabsWixAppParams>
 */
export function groupsManageTabsWixApp(params) {
    return { evid: 753, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsCreateGroupClick' event (evid: 763)
 *
 * Event description: Groups-> Create Group Click.
 *
 * @param {groupsCreateGroupClickParams} params - The parameters for this event
 * @property {string} container - container
 * @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
 * @property {string} userEntry - bizmgr/site/editor/oneapp
 * @property {GUID} templateId - template id
 * @property {string} origin - plus_btn / empty_state_btn / settings_create_first_grp_btn / groups_templates_scr
 * @property {string} step - flow step
 * @return {LogObject<groupsCreateGroupClickParams>} LogObject<groupsCreateGroupClickParams>
 */
export function groupsCreateGroupClick(params) {
    return { evid: 763, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsRestrictedToEvent' event (evid: 77)
 *
 * Event description: Joining Group restricted to the event(s)
 *
 * @param {groupsRestrictedToEventParams} params - The parameters for this event
 * @property {string} userEntry - oneapp
 * @property {string} origin - view_event/view_events
 * @property {string} action - view/close
 * @return {LogObject<groupsRestrictedToEventParams>} LogObject<groupsRestrictedToEventParams>
 */
export function groupsRestrictedToEvent(params) {
    return { evid: 77, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSelectPricingPlan' event (evid: 78)
 *
 * Event description: User clicked on PP link
 *
 * @param {groupsSelectPricingPlanParams} params - The parameters for this event
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - oneapp/bizmngr/site
 * @property {string} origin - mobile_group_creation
 * @property {boolean} isVisible - true/false
 * @property {string} type - public/private
 * @return {LogObject<groupsSelectPricingPlanParams>} LogObject<groupsSelectPricingPlanParams>
 */
export function groupsSelectPricingPlan(params) {
    return { evid: 78, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newEventCreateYourGroupPageLoad' event (evid: 780)
 *
 * Event description: user is viewing create your group page (with form to fill)
 *
 * @param {newEventCreateYourGroupPageLoadParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @return {LogObject<newEventCreateYourGroupPageLoadParams>} LogObject<newEventCreateYourGroupPageLoadParams>
 */
export function newEventCreateYourGroupPageLoad(params) {
    return { evid: 780, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsCreateSelectEvent' event (evid: 79)
 *
 * Event description: Select Event to create restricted group
 *
 * @param {groupsCreateSelectEventParams} params - The parameters for this event
 * @property {GUID} groupId - null
 * @property {string} origin - mobile_group_creation
 * @property {string} type - PRIVATE
 * @return {LogObject<groupsCreateSelectEventParams>} LogObject<groupsCreateSelectEventParams>
 */
export function groupsCreateSelectEvent(params) {
    return { evid: 79, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsPageView' event (evid: 8)
 *
 * Event description: Open Groups Page
 *
 * @param {groupsPageViewParams} params - The parameters for this event
 * @property {GUID} groupId - guid
 * @property {string} userEntry - bizmgr/site/members_area/oneapp
 * @property {string} viewOn - website / members_app
 * @property {string} origin - explore_groups_button/link/etc...
 * @return {LogObject<groupsPageViewParams>} LogObject<groupsPageViewParams>
 */
export function groupsPageView(params) {
    return { evid: 8, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showInGroupList' event (evid: 81)
 *
 * Event description: Toggle/checkbox to show group in list
 *
 * @param {showInGroupListParams} params - The parameters for this event
 * @property {boolean} toggle - True/False
 * @property {string} userEntry - bizmngr/oneapp
 * @property {string} origin - group_creation/mobile_group_creation
 * @return {LogObject<showInGroupListParams>} LogObject<showInGroupListParams>
 */
export function showInGroupList(params) {
    return { evid: 81, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsEventsClick' event (evid: 82)
 *
 * Event description: Groups Events Click.
 *
 * @param {groupsEventsClickParams} params - The parameters for this event
 * @property {string} userEntry - bizmngr
 * @property {string} origin - restrict_group_to_event
 * @property {string} buttonName - add_eventremove/add_another_event//create_event
 * @return {LogObject<groupsEventsClickParams>} LogObject<groupsEventsClickParams>
 */
export function groupsEventsClick(params) {
    return { evid: 82, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedClickSrc111Evid820' event (evid: 820)
 *
 * Event description: Click on the button on group feed
 *
 * @param {groupFeedClickSrc111Evid820Params} params - The parameters for this event
 * @property {string} button_name - group_list
 * @return {LogObject<groupFeedClickSrc111Evid820Params>} LogObject<groupFeedClickSrc111Evid820Params>
 */
export function groupFeedClickSrc111Evid820(params) {
    return { evid: 820, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupFeedView' event (evid: 821)
 *
 * Event description: Group Feed View.
 *
 * @param {groupFeedViewParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {boolean} has_only_auto_post - has_only_auto_post
 * @property {string} container - container
 * @property {string} userEntry - site
 * @property {string} roles - user_roles
 * @property {string} origin - discussion_tab
 * @property {GUID} clubId - club_id
 * @property {GUID} msid - msid
 * @property {GUID} visitor_id - visitor_id
 * @return {LogObject<groupFeedViewParams>} LogObject<groupFeedViewParams>
 */
export function groupFeedView(params) {
    return { evid: 821, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsChangedDefaultSort' event (evid: 822)
 *
 * Event description: Groups: changed default sort.
 *
 * @param {groupsChangedDefaultSortParams} params - The parameters for this event
 * @property {string} sort_by - sort_by
 * @return {LogObject<groupsChangedDefaultSortParams>} LogObject<groupsChangedDefaultSortParams>
 */
export function groupsChangedDefaultSort(params) {
    return { evid: 822, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsChoseGroupsSortBy' event (evid: 823)
 *
 * Event description: Groups: chose groups sort by.
 *
 * @param {groupsChoseGroupsSortByParams} params - The parameters for this event
 * @property {string} userEntry - site / bizmngr
 * @property {string} origin - popup_menu
 * @property {string} sort_by - sort_by
 * @return {LogObject<groupsChoseGroupsSortByParams>} LogObject<groupsChoseGroupsSortByParams>
 */
export function groupsChoseGroupsSortBy(params) {
    return { evid: 823, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSearchForGroup' event (evid: 824)
 *
 * Event description: Groups -> Search for Group.
 *
 * @param {groupsSearchForGroupParams} params - The parameters for this event
 * @property {string} userEntry - site / bizmngr
 * @property {string} group_name - search term
 * @property {string} origin - top_panel_editbox
 * @return {LogObject<groupsSearchForGroupParams>} LogObject<groupsSearchForGroupParams>
 */
export function groupsSearchForGroup(params) {
    return { evid: 824, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsFeedClickOnGroupList' event (evid: 827)
 *
 * Event description: Groups Feed - Click on Group List
 *
 * @param {groupsFeedClickOnGroupListParams} params - The parameters for this event
 * @property {string} groupsList - string with comma separated list of connected groupIds
 * @property {string} userEntry - site / bizmngr /wixapp
 * @property {string} origin - my_groups_carousel etc
 * @property {number} groupsCnt - count of connected groups
 * @return {LogObject<groupsFeedClickOnGroupListParams>} LogObject<groupsFeedClickOnGroupListParams>
 */
export function groupsFeedClickOnGroupList(params) {
    return { evid: 827, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsFeedClickSeeAll' event (evid: 828)
 *
 * Event description: Groups Feed - Click See All in unified feed
 *
 * @param {groupsFeedClickSeeAllParams} params - The parameters for this event
 * @property {string} userEntry - site / bizmngr /wixapp
 * @return {LogObject<groupsFeedClickSeeAllParams>} LogObject<groupsFeedClickSeeAllParams>
 */
export function groupsFeedClickSeeAll(params) {
    return { evid: 828, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupPostClickOnOptions' event (evid: 83)
 *
 * Event description: Group Post -> Click on options.
 *
 * @param {groupPostClickOnOptionsParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {GUID} club_id - club_id
 * @property {string} container - container
 * @property {string} userEntry - oneapp/ site / bizmngr
 * @property {string} userClass - user_class
 * @property {string} postId - post_id
 * @property {string} origin - post_three_dots
 * @property {GUID} clubId - club_id
 * @return {LogObject<groupPostClickOnOptionsParams>} LogObject<groupPostClickOnOptionsParams>
 */
export function groupPostClickOnOptions(params) {
    return { evid: 83, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsManageGroups' event (evid: 830)
 *
 * Event description: Groups -> Manage Events Groups Button Click
 *
 * @param {groupsManageGroupsParams} params - The parameters for this event
 * @property {string} userEntry - oneapp/bizmngr/editor etc
 * @property {string} origin - admin_widget etc
 * @property {string} buttonName - connect_group, manage_group, disconnect etc
 * @property {GUID} event_id - event ID
 * @return {LogObject<groupsManageGroupsParams>} LogObject<groupsManageGroupsParams>
 */
export function groupsManageGroups(params) {
    return { evid: 830, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupManagePostClick' event (evid: 833)
 *
 * Event description: manage post panel inside ownerapp click
 *
 * @param {groupManagePostClickParams} params - The parameters for this event
 * @property {GUID} groupId - guid
 * @property {string} userEntry - ownerapp
 * @property {string} origin - manage_post_ownerapp
 * @return {LogObject<groupManagePostClickParams>} LogObject<groupManagePostClickParams>
 */
export function groupManagePostClick(params) {
    return { evid: 833, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupPendingMembers' event (evid: 837)
 *
 * Event description: Click pending members/group request CTA
 *
 * @param {groupPendingMembersParams} params - The parameters for this event
 * @property {string} userEntry - oneapp
 * @property {string} origin - banner
 * @property {GUID} msid - guid
 * @return {LogObject<groupPendingMembersParams>} LogObject<groupPendingMembersParams>
 */
export function groupPendingMembers(params) {
    return { evid: 837, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showNewEventUpdateToggle' event (evid: 838)
 *
 * Event description: Group auto-post settings toggle click
 *
 * @param {showNewEventUpdateToggleParams} params - The parameters for this event
 * @property {boolean} toggle - true/false
 * @property {GUID} groupId - guid
 * @property {string} origin - manage_group_updates_scr
 * @property {string} userEntry - userEntry
 * @property {string} settingName - name of the setting: events, new_members, group_details
 * @return {LogObject<showNewEventUpdateToggleParams>} LogObject<showNewEventUpdateToggleParams>
 */
export function showNewEventUpdateToggle(params) {
    return { evid: 838, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsEditorSettingPanelOpened' event (evid: 839)
 *
 * Event description: Groups Setting Panel Opened in Editor
 *
 * @param {groupsEditorSettingPanelOpenedParams} params - The parameters for this event
 * @property {GUID} uuid - guid
 * @property {string} panel_name - groups / list_widget / sidebyside / feed_widget
 * @property {GUID} msid - guid
 * @return {LogObject<groupsEditorSettingPanelOpenedParams>} LogObject<groupsEditorSettingPanelOpenedParams>
 */
export function groupsEditorSettingPanelOpened(params) {
    return { evid: 839, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ppGroupsButtonClick' event (evid: 84)
 *
 * Event description: PP Groups Button Click during creation flow
 *
 * @param {ppGroupsButtonClickParams} params - The parameters for this event
 * @property {string} userEntry - bizmngr
 * @property {string} ppID - pp_id
 * @property {string} origin - origin
 * @property {string} buttonName - name of the button
 * @property {string} action - select/unselect/null
 * @return {LogObject<ppGroupsButtonClickParams>} LogObject<ppGroupsButtonClickParams>
 */
export function ppGroupsButtonClick(params) {
    return { evid: 84, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsEditorWidgetAdded' event (evid: 840)
 *
 * Event description: Groups editor widget added to the page
 *
 * @param {groupsEditorWidgetAddedParams} params - The parameters for this event
 * @property {string} widget_name - list_widget / sidebyside / feed_widget
 * @property {GUID} uuid - guid
 * @property {string} page_name - page name
 * @property {GUID} msid - guid
 * @return {LogObject<groupsEditorWidgetAddedParams>} LogObject<groupsEditorWidgetAddedParams>
 */
export function groupsEditorWidgetAdded(params) {
    return { evid: 840, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmClickOnButton' event (evid: 844)
 *
 * Event description: BM -> click on button
 *
 * @param {bmClickOnButtonParams} params - The parameters for this event
 * @property {string} description - click name
 * @property {GUID} groupId - guid
 * @property {string} entity_id - post id
 * @property {string} origin - click screen origin
 * @property {GUID} msid - site id
 * @return {LogObject<bmClickOnButtonParams>} LogObject<bmClickOnButtonParams>
 */
export function bmClickOnButton(params) {
    return { evid: 844, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsMobileAppClickOnButton' event (evid: 845)
 *
 * Event description: groups mobile app -> click on button
 *
 * @param {groupsMobileAppClickOnButtonParams} params - The parameters for this event
 * @property {GUID} group_id - guid
 * @property {string} description - .
 * @property {string} data - string
 * @property {string} origin - origin
 * @property {GUID} site_member_id - guid
 * @property {GUID} msid - guid
 * @return {LogObject<groupsMobileAppClickOnButtonParams>} LogObject<groupsMobileAppClickOnButtonParams>
 */
export function groupsMobileAppClickOnButton(params) {
    return { evid: 845, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsMobileAppWindowOpened' event (evid: 846)
 *
 * Event description: groups mobile app - window opened
 *
 * @param {groupsMobileAppWindowOpenedParams} params - The parameters for this event
 * @property {GUID} group_id - group id
 * @property {string} window_name - window_name
 * @property {GUID} site_member_id - id
 * @property {GUID} msid - id
 * @return {LogObject<groupsMobileAppWindowOpenedParams>} LogObject<groupsMobileAppWindowOpenedParams>
 */
export function groupsMobileAppWindowOpened(params) {
    return { evid: 846, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsLivesiteClick' event (evid: 848)
 *
 * Event description: click on livesite
 *
 * @param {groupsLivesiteClickParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {string} screen_name - screen name
 * @property {string} button_name - button name
 * @property {GUID} site_member_id - id
 * @property {GUID} msid - id
 * @return {LogObject<groupsLivesiteClickParams>} LogObject<groupsLivesiteClickParams>
 */
export function groupsLivesiteClick(params) {
    return { evid: 848, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupListLoaded' event (evid: 849)
 *
 * Event description: Group List Loaded
 *
 * @param {groupListLoadedParams} params - The parameters for this event
 * @property {string} layout_type - list_layout / grid_layout / group_carousel
 * @property {string} userEntry - livesite / editor
 * @property {GUID} site_member_id - guid
 * @property {GUID} msid - guid
 * @property {boolean} show_feed - If feed is on
 * @return {LogObject<groupListLoadedParams>} LogObject<groupListLoadedParams>
 */
export function groupListLoaded(params) {
    return { evid: 849, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clubPostOptionsClickDelete' event (evid: 85)
 *
 * Event description: Club post -> options -> click delete.
 *
 * @param {clubPostOptionsClickDeleteParams} params - The parameters for this event
 * @property {GUID} post_id - post_id
 * @property {GUID} club_id - club_id
 * @property {string} container - container
 * @property {string} userClass - user_class
 * @property {GUID} postId - post_id
 * @property {string} type - type
 * @property {GUID} clubId - club_id
 * @return {LogObject<clubPostOptionsClickDeleteParams>} LogObject<clubPostOptionsClickDeleteParams>
 */
export function clubPostOptionsClickDelete(params) {
    return { evid: 85, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'communityTabButtonClick' event (evid: 851)
 *
 * Event description: Community Tab -> button click
 *
 * @param {communityTabButtonClickParams} params - The parameters for this event
 * @property {string} screen_name - screen_name
 * @property {GUID} uuid - guid
 * @property {string} cta_name - cta_name
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} msid - guid
 * @return {LogObject<communityTabButtonClickParams>} LogObject<communityTabButtonClickParams>
 */
export function communityTabButtonClick(params) {
    return { evid: 851, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'communityTabWindowLoaded' event (evid: 852)
 *
 * Event description: Community Tab -> window loaded
 *
 * @param {communityTabWindowLoadedParams} params - The parameters for this event
 * @property {string} dealer_offers - list of offer_ids (comma separated string)
 * @property {string} screen_name - screen_name
 * @property {GUID} uuid - uuid
 * @property {string} recommended_apps - list of app_guids (comma separated string)
 * @property {string} suggested_automations - list of automations (comma separated  string)
 * @property {GUID} msid - msid
 * @property {string} installed_apps - list of app_guids (comma separated  string)
 * @return {LogObject<communityTabWindowLoadedParams>} LogObject<communityTabWindowLoadedParams>
 */
export function communityTabWindowLoaded(params) {
    return { evid: 852, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'communityTabSuccessToast' event (evid: 853)
 *
 * Event description: Community Tab -> success toast
 *
 * @param {communityTabSuccessToastParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} toast_name - toast_name
 * @property {string} app_name - app_name
 * @property {GUID} msid - msid
 * @return {LogObject<communityTabSuccessToastParams>} LogObject<communityTabSuccessToastParams>
 */
export function communityTabSuccessToast(params) {
    return { evid: 853, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paidPostMonetizeClick' event (evid: 854)
 *
 * Event description: paid post -> monetize click
 *
 * @param {paidPostMonetizeClickParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} uuid - uuid
 * @property {string} ctaName - monetize / monetize_icon
 * @property {GUID} msid - msid
 * @return {LogObject<paidPostMonetizeClickParams>} LogObject<paidPostMonetizeClickParams>
 */
export function paidPostMonetizeClick(params) {
    return { evid: 854, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'paidPostSubscribeClick' event (evid: 855)
 *
 * Event description: paid post -> subscribe click
 *
 * @param {paidPostSubscribeClickParams} params - The parameters for this event
 * @property {GUID} group_id - group_id
 * @property {GUID} post_id - post_id
 * @property {string} post_details - json converted to string
 * @property {GUID} msid - msid
 * @return {LogObject<paidPostSubscribeClickParams>} LogObject<paidPostSubscribeClickParams>
 */
export function paidPostSubscribeClick(params) {
    return { evid: 855, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmWindowLoaded' event (evid: 856)
 *
 * Event description: BM -> window loaded
 *
 * @param {bmWindowLoadedParams} params - The parameters for this event
 * @property {GUID} groupId - guid
 * @property {string} window_name - window_name
 * @property {GUID} msid - msid
 * @return {LogObject<bmWindowLoadedParams>} LogObject<bmWindowLoadedParams>
 */
export function bmWindowLoaded(params) {
    return { evid: 856, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsErrorEvent' event (evid: 857)
 *
 * Event description: Error Screen Fired
 *
 * @param {groupsErrorEventParams} params - The parameters for this event
 * @property {string} platform - Mobile App Name / Bizmngr / Livesite
 * @property {string} screen_name - screen_name
 * @return {LogObject<groupsErrorEventParams>} LogObject<groupsErrorEventParams>
 */
export function groupsErrorEvent(params) {
    return { evid: 857, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clubPostOptionsClickEdit' event (evid: 86)
 *
 * Event description: Club post -> options -> click edit.
 *
 * @param {clubPostOptionsClickEditParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {GUID} club_id - club_id
 * @property {GUID} saleItemId - sale_item_id
 * @property {string} container - container
 * @property {string} userClass - user_class
 * @property {string} postId - post_id
 * @property {string} type - type
 * @property {GUID} clubId - club_id
 * @return {LogObject<clubPostOptionsClickEditParams>} LogObject<clubPostOptionsClickEditParams>
 */
export function clubPostOptionsClickEdit(params) {
    return { evid: 86, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clubPostViewPostFullScreen' event (evid: 87)
 *
 * Event description: Club post -> view post full screen.
 *
 * @param {clubPostViewPostFullScreenParams} params - The parameters for this event
 * @property {string} post_id - post_id
 * @property {GUID} club_id - club_id
 * @property {boolean} isPinned - is_pinned
 * @property {string} container - container
 * @property {string} userEntry - bizmngr / site
 * @property {string} userClass - user_class
 * @property {string} postId - post_id
 * @property {string} origin - groups_my_posts_tab / groups_my_groups_tab
 * @property {string} app_id - app_id
 * @property {string} type - type
 * @property {GUID} clubId - club_id
 * @return {LogObject<clubPostViewPostFullScreenParams>} LogObject<clubPostViewPostFullScreenParams>
 */
export function clubPostViewPostFullScreen(params) {
    return { evid: 87, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'joinRestrictedGroup' event (evid: 88)
 *
 * Event description: Join Restricted Group
 *
 * @param {joinRestrictedGroupParams} params - The parameters for this event
 * @property {string} userEntry - livesite
 * @property {string} origin - group_list/join_button/discussions _tab/get_another_plan
 * @property {string} type - paid_plans/events
 * @return {LogObject<joinRestrictedGroupParams>} LogObject<joinRestrictedGroupParams>
 */
export function joinRestrictedGroup(params) {
    return { evid: 88, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'inviteSent' event (evid: 9)
 *
 * Event description: Group -> Invite Members -> Send Invite Done
 *
 * @param {inviteSentParams} params - The parameters for this event
 * @property {GUID} group_id - group ID
 * @property {number} count - cnt of members invited
 * @property {string} contact - e-mail address
 * @property {GUID} groupId - group ID
 * @property {string} userEntry - bizmngr/site
 * @property {boolean} selectAll - true/false
 * @property {string} origin - dialog_scr_invite_btn
 * @property {GUID} site_member_id - site_member_id
 * @property {string} user_role - Owner / uou
 * @return {LogObject<inviteSentParams>} LogObject<inviteSentParams>
 */
export function inviteSent(params) {
    return { evid: 9, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsSelectNotificationsSettings' event (evid: 92)
 *
 * Event description: Groups WixApp-> Select Notifications Settings
 *
 * @param {groupsSelectNotificationsSettingsParams} params - The parameters for this event
 * @property {GUID} groupId - guid
 * @property {string} userEntry - oneapp
 * @property {string} click - notifications/email_notifications
 * @property {string} origin - group_dashboard
 * @property {string} type - member/owner
 * @property {GUID} siteMemberId - guid
 * @return {LogObject<groupsSelectNotificationsSettingsParams>} LogObject<groupsSelectNotificationsSettingsParams>
 */
export function groupsSelectNotificationsSettings(params) {
    return { evid: 92, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsManageAppEmailNotifications' event (evid: 93)
 *
 * Event description: WixApp Groups-> Manage App Email Notifications
 *
 * @param {groupsManageAppEmailNotificationsParams} params - The parameters for this event
 * @property {boolean} membersJoinedToggle - true/false
 * @property {GUID} groupId - guid
 * @property {string} userEntry - oneapp
 * @property {boolean} postsToggle - true/false
 * @property {string} origin - group_dashboard
 * @property {boolean} commentsToggle - true/false
 * @property {boolean} weeklyDigestToggle - weekly_digest_toggle
 * @property {string} type - member/owner
 * @property {boolean} groupNotificationToggle - true/false
 * @property {GUID} siteMemberId - guid
 * @return {LogObject<groupsManageAppEmailNotificationsParams>} LogObject<groupsManageAppEmailNotificationsParams>
 */
export function groupsManageAppEmailNotifications(params) {
    return { evid: 93, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsEmptyStateClick' event (evid: 94)
 *
 * Event description: Groups -> Empty State Click
 *
 * @param {groupsEmptyStateClickParams} params - The parameters for this event
 * @property {string} userEntry - wixapp
 * @property {string} origin - group_feed_empty_state
 * @property {string} buttonName - contact_owner
 * @return {LogObject<groupsEmptyStateClickParams>} LogObject<groupsEmptyStateClickParams>
 */
export function groupsEmptyStateClick(params) {
    return { evid: 94, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsManageAppNotifications' event (evid: 95)
 *
 * Event description: WixApp Groups Notifications
 *
 * @param {groupsManageAppNotificationsParams} params - The parameters for this event
 * @property {boolean} reactionsToggle - true/false
 * @property {boolean} membersJoinedToggle - true/false
 * @property {GUID} groupId - guid
 * @property {string} userEntry - oneapp
 * @property {boolean} newMemberToggle - true/false
 * @property {boolean} postsToggle - true/false
 * @property {string} origin - group_dashboard
 * @property {boolean} commentsToggle - true/false
 * @property {GUID} site_member_id - guid
 * @property {string} type - member/owner
 * @property {boolean} groupNotificationToggle - true/false
 * @return {LogObject<groupsManageAppNotificationsParams>} LogObject<groupsManageAppNotificationsParams>
 */
export function groupsManageAppNotifications(params) {
    return { evid: 95, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupShareSomethingClick' event (evid: 96)
 *
 * Event description: Group -> Share Something Click.
 *
 * @param {groupShareSomethingClickParams} params - The parameters for this event
 * @property {string} userEntry - user_entry
 * @property {string} origin - origin
 * @property {GUID} msid - msid
 * @return {LogObject<groupShareSomethingClickParams>} LogObject<groupShareSomethingClickParams>
 */
export function groupShareSomethingClick(params) {
    return { evid: 96, src: 111, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollCreated' event (evid: 1000)
 *
 * Event description: When Poll first saved on server
 *
 * @param {pollCreatedParams} params - The parameters for this event
 * @property {string} userRole - poll owner/ member
 * @property {boolean} votersDisplay - shows voters
 * @property {string} voteRole - site_members / all
 * @property {string} resultsVisibility - voters / site_members / all
 * @property {string} pollId_ - poll id
 * @property {string} dataJson - JSON with PollName, PollAnswersCount, PollAnswersList, ImagesCount
 * @property {boolean} withImage - has image
 * @property {boolean} multipleVotes - allows multiple votes
 * @property {boolean} votesDisplay - shows votes
 * @return {LogObject<pollCreatedParams>} LogObject<pollCreatedParams>
 */
export function pollCreated(params) {
    return { evid: 1000, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollVote' event (evid: 1100)
 *
 * Event description: When poll vote registered on server
 *
 * @param {pollVoteParams} params - The parameters for this event
 * @property {boolean} isAutomaticUnvote - if unvoted automatically after clicking other vote option
 * @property {string} userRole - poll owner / member
 * @property {string} voteType - vote / un_vote
 * @property {string} pollId_ - poll id
 * @return {LogObject<pollVoteParams>} LogObject<pollVoteParams>
 */
export function pollVote(params) {
    return { evid: 1100, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollVoteClick' event (evid: 20)
 *
 * Event description: When user click on poll to vote / un-vote
 *
 * @param {pollVoteClickParams} params - The parameters for this event
 * @property {string} screenName - screen name in oneapp / site
 * @property {string} voteType - vote. / un_vote
 * @property {string} answerId - answer ID
 * @property {GUID} groupId - if selected from the Group
 * @property {string} userEntry - oneapp / site
 * @property {string} pollId_ - poll Id
 * @return {LogObject<pollVoteClickParams>} LogObject<pollVoteClickParams>
 */
export function pollVoteClick(params) {
    return { evid: 20, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'exampleEvent' event (evid: 201)
 *
 * Event description: example for test
 *
 * @param {exampleEventParams} params - The parameters for this event
 * @property {string} title - title
 * @return {LogObject<exampleEventParams>} LogObject<exampleEventParams>
 */
export function exampleEvent(params) {
    return { evid: 201, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollVoteError' event (evid: 21)
 *
 * Event description: Poll Error - in Poll editor or in Poll viewer trying to vote
 *
 * @param {pollVoteErrorParams} params - The parameters for this event
 * @property {string} screenName - screen name in oneapp / site
 * @property {string} userEntry - oneapp / site
 * @property {string} pollId_ - poll Id
 * @property {string} origin - editor / viewer_vote_error
 * @return {LogObject<pollVoteErrorParams>} LogObject<pollVoteErrorParams>
 */
export function pollVoteError(params) {
    return { evid: 21, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollVoteTryAgainClick' event (evid: 22)
 *
 * Event description: Poll Vote Try Again Click
 *
 * @param {pollVoteTryAgainClickParams} params - The parameters for this event
 * @property {string} screenName - screen name in oneapp / site
 * @property {string} userEntry - oneapp / site
 * @property {string} pollId_ - poll Id
 * @return {LogObject<pollVoteTryAgainClickParams>} LogObject<pollVoteTryAgainClickParams>
 */
export function pollVoteTryAgainClick(params) {
    return { evid: 22, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollVotersListClick' event (evid: 23)
 *
 * Event description: Poll Voters List Click
 *
 * @param {pollVotersListClickParams} params - The parameters for this event
 * @property {string} screenName - screen name in oneapp / site
 * @property {string} userEntry - oneapp / site
 * @property {string} pollId_ - poll Id
 * @property {string} origin - poll / voter
 * @return {LogObject<pollVotersListClickParams>} LogObject<pollVotersListClickParams>
 */
export function pollVotersListClick(params) {
    return { evid: 23, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollSettingsButtonClick' event (evid: 4)
 *
 * Event description: When user clicks any of the polls settings buttons
 *
 * @param {pollSettingsButtonClickParams} params - The parameters for this event
 * @property {string} screenName - screen name in oneapp / site
 * @property {string} tabName - tab name where click happened - layout / design / settings
 * @property {GUID} groupId - if selected from the Group
 * @property {string} userEntry - oneapp / site
 * @property {string} pollId_ - poll Id
 * @property {string} buttonName - name of the button,for example select_text_list / select_text_img / select_grid / close etc
 * @return {LogObject<pollSettingsButtonClickParams>} LogObject<pollSettingsButtonClickParams>
 */
export function pollSettingsButtonClick(params) {
    return { evid: 4, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pollSettingsTabClick' event (evid: 5)
 *
 * Event description: Poll Settings Tab Click.
 *
 * @param {pollSettingsTabClickParams} params - The parameters for this event
 * @property {string} screenName - screen name in oneapp / site
 * @property {string} originTabName - from tab where click was triggered - create_poll / layout / design / settings
 * @property {GUID} groupId - if selected from the Group
 * @property {string} userEntry - oneapp / site
 * @property {string} pollId_ - poll id
 * @property {string} targetTabName - target_tab_name
 * @return {LogObject<pollSettingsTabClickParams>} LogObject<pollSettingsTabClickParams>
 */
export function pollSettingsTabClick(params) {
    return { evid: 5, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectPollDescriptionTextField' event (evid: 6)
 *
 * Event description: Select Poll Description Text Field
 *
 * @param {selectPollDescriptionTextFieldParams} params - The parameters for this event
 * @property {string} screenName - screen name in oneapp / site
 * @property {string} userEntry - oneapp / site
 * @property {string} pollId_ - poll id
 * @property {string} origin - question / answer
 * @return {LogObject<selectPollDescriptionTextFieldParams>} LogObject<selectPollDescriptionTextFieldParams>
 */
export function selectPollDescriptionTextField(params) {
    return { evid: 6, src: 120, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsChanged' event (evid: 200)
 *
 * Event description: Component configuration was changed via Settings panel
 *
 * @param {settingsChangedParams} params - The parameters for this event
 * @property {string} parameter - Name of the field
 * @property {boolean} isMobile - Event sent from a mobile form factor
 * @property {string} appName - Application Name
 * @property {string} componentId - ID of the component in Dev Center
 * @property {string} componentName - Name of the component in Dev Center
 * @property {string} origin - editor/editor_x/ADI
 * @property {string} category - Settings panel tab
 * @property {string} value - Updated value
 * @return {LogObject<settingsChangedParams>} LogObject<settingsChangedParams>
 */
export function settingsChanged(params) {
    return { evid: 200, src: 127, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsTabClicked' event (evid: 201)
 *
 * Event description: Settings panel left-side tab was clicked.
 *
 * @param {settingsTabClickedParams} params - The parameters for this event
 * @property {boolean} isMobile - Event sent from a mobile form factor
 * @property {string} appName - Application Name
 * @property {string} componentId - ID of the component in Dev Center
 * @property {string} componentName - Name of the component in Dev Center
 * @property {string} tabName - Name of the clicked tab
 * @property {string} origin - editor/editor_x/ADI
 * @return {LogObject<settingsTabClickedParams>} LogObject<settingsTabClickedParams>
 */
export function settingsTabClicked(params) {
    return { evid: 201, src: 127, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsMemberRequestApproveDeclineSrc67Evid576' event (evid: 576)
 *
 * Event description: When user clicks to approve / decline a member request
 *
 * @param {groupsMemberRequestApproveDeclineSrc67Evid576Params} params - The parameters for this event
 * @property {boolean} isPreviewMode - is_preview_mode
 * @property {number} ts - ts
 * @property {string} moduleName - module_name
 * @property {boolean} isSplitInstance - is_split_instance
 * @property {string} moduleVersion - module_version
 * @property {string} groupId - the group id
 * @property {string} user_agent - user_agent
 * @property {GUID} contactId - contact_id
 * @property {GUID} memberId - the member uid - should be null if all
 * @property {string} appNameInstance - app_name_instance
 * @property {boolean} isAll - if all option s was selected
 * @property {string} type - approve/decline
 * @return {LogObject<groupsMemberRequestApproveDeclineSrc67Evid576Params>} LogObject<groupsMemberRequestApproveDeclineSrc67Evid576Params>
 */
export function groupsMemberRequestApproveDeclineSrc67Evid576(params) {
    return { evid: 576, src: 67, endpoint: '', params };
}
/**
 * A function to create a log object for the 'groupsPermisionForUouToCreateAGroupSrc67Evid604' event (evid: 604)
 *
 * Event description: When a user switches a toggle on/off from within the groups settings.
 *
 * @param {groupsPermisionForUouToCreateAGroupSrc67Evid604Params} params - The parameters for this event
 * @property {boolean} isPreviewMode - is_preview_mode
 * @property {number} ts - ts
 * @property {string} moduleName - module_name
 * @property {boolean} isSplitInstance - is_split_instance
 * @property {string} moduleVersion - module_version
 * @property {string} user_agent - user_agent
 * @property {GUID} contactId - contact_id
 * @property {string} appNameInstance - app_name_instance
 * @property {string} permisionForUouToCreateAGroup - who can create a group
 * @return {LogObject<groupsPermisionForUouToCreateAGroupSrc67Evid604Params>} LogObject<groupsPermisionForUouToCreateAGroupSrc67Evid604Params>
 */
export function groupsPermisionForUouToCreateAGroupSrc67Evid604(params) {
    return { evid: 604, src: 67, endpoint: '', params };
}
//# sourceMappingURL=index.js.map